import * as Yup from 'yup'
import axios from 'axios'
import { Icon } from '@iconify/react'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import arrowLeftFill from '@iconify/icons-eva/arrow-back-fill';
import { isAdminUser } from '../../utils/adminUserTypes';
import layersFill from '@iconify/icons-eva/layers-fill'
import plusCircleOutline from '@iconify/icons-eva/plus-circle-outline'
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { capitalCase, sentenceCase } from 'change-case'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Container,
  Grid,
  IconButton,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  Checkbox,
  Card,
  TableCell,
  Typography,
  TableContainer,
  Table,
  TablePagination,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Divider,
  Paper,
  Popover,
  CardHeader,
  TableHead,
  List,
  Menu,
  MenuItem,
  ListItemText,
  ListItem,
  Tabs,
  Tab,
  Tooltip,
  CircularProgress,
  Badge,
  FormHelperText,
  ButtonGroup,
  Skeleton,
  ListItemIcon,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core'
import CloseIcon from '@iconify/icons-eva/close-fill'
import {
  useTheme,
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import plusFill from '@iconify/icons-eva/plus-fill'
// redux
import {
  LoadingButton,
  MobileDatePicker,
  MobileDateRangePicker,
} from '@material-ui/lab'
// routes
// components
import Page from '../../components/Page'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import Modal from '../../components/_dashboard/blog/ProjectModel'
import Label from 'src/components/Label'
import { useSnackbar } from 'notistack'
import {
  Delete,
  UploadFile,
  LocationOn,
  ExpandMore,
  ExpandLess,
  Remove,
  Add,
  NoteAdd,
  Visibility,
  VisibilityOff,
  ViewModule,
  ViewList,
  List as ListIcon,
  Settings,
  FilterList,
  Build,
  Storefront,
  Construction,
  CallSplit,
} from '@material-ui/icons'
import OfficialRequestSearch from 'src/components/_dashboard/official-request/OfficialRequestSearch'
import InfiniteScroll from 'react-infinite-scroll-component'
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard'
import Scrollbar from 'src/components/Scrollbar'
import moment from 'moment'
import {
  REST_API,
  REST_API_END_POINT,
  UNITS,
} from 'src/constants/Defaultvalues'
import { UploadAvatar, UploadMultiFile } from 'src/components/upload'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import ReactToPrint from 'react-to-print'
import { empty } from 'src/Helpers/Common'
import LoadingScreen from 'src/components/LoadingScreen'
import SearchNotFound from 'src/components/SearchNotFound'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import OfficialRequestAddPreview from './OfficialRequestAddPreview'
import OfficialRequestAdd from './OfficialRequestAdd'
import { MIconButton } from 'src/components/@material-extend'
import FullScreenDialogSalesOrder from '../components-overview/material-ui/dialog/FullScreenDialogSalesOrder';
import DesignOrderList from './DesignOrderList';
import { use } from 'react';

const SkeletonLoad = () => (
  <Grid container spacing={3} sx={{ padding: 2 }}>
    {[...Array(3)].map((_, index) => (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Skeleton variant="rectangular" width="100%" sx={{ height: 200, borderRadius: 2 }} />
        <Box sx={{ display: 'flex', mt: 1.5 }}>
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Skeleton variant="text" sx={{ mx: 1, flexGrow: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);

const getStatusColorAndLabel = (status, manager_approval_required) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' }
    case 2:
      return { color: 'info', label: 'Status: Open' }
    case 3:
      return { color: 'primary', label: 'Status: Accepted' } // Evaluating
    case 4:
      return { color: 'success', label: 'Status: In Production' } // Converted to Job
    case 5:
      return { color: 'warning', label: 'Status: Closed' }
    case 6:
      return { color: 'error', label: 'Status: Rejected' }
    case 9:
      // return { color: 'info', label: (manager_approval_required === true || manager_approval_required === 1) ? 'Status: Awaiting Manager Approval' : 'Status: Awaiting Approval' }
      return { color: 'info', label: 'Status: Awaiting Approval' }
    default:
      return { color: 'default', label: 'Status: Open' }
  }
}

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' },
]
const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  // { id: 3, name: '¢' }
]

//sorting
const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' },
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
]

const MAX_CHARACTERS = 100
  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))

// Dashboard layout scrolls a main column (overflow: auto), not the window.
// scrollIntoView can stop short; forcing scrollTop on each vertical scroll ancestor reaches the real top.
function scrollDashboardAncestorsToTop(fromNode) {
  if (typeof window === 'undefined' || !fromNode) return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = fromNode
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }
}

export default function OfficialRequest({ splitOrder = false }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const locationState = useLocation()
  const newTab = locationState.state?.newTab
  const [searching, setSearching] = useState('')
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(0)
  const [preview, setPreview] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [totalCount, setTotalCount] = useState(0)
  const [allCount, setAllCount] = useState(0)
  const [acceptedCount, setAcceptedCount] = useState(0)
  const [rejectedCount, setRejectedCount] = useState(0)
  const [openCount, setOpenCount] = useState(0)
  const [inProductionCount, setinProductionCount] = useState(0)
  const [completedCount, setCompletedCount] = useState(0)
  const [installsCount, setInstallsCount] = useState(0)
  const [pickupCount, setPickupCount] = useState(0)
  const [invoiceCount, setInvoiceCount] = useState(0)
  const [shippingCount, setShippingCount] = useState(0)
  const [holdCount, setHoldCount] = useState(0)
  const [voidCount, setVoidCount] = useState(0)
  const [returnedCount, setReturnedCount] = useState(0)
  const [tabGlowFlags, setTabGlowFlags] = useState({})
  const [allRequest, setAllRequest] = useState([])
  const [loadingCards, setLoadingCards] = useState(true)
  const [loadingCardsAdd, setLoadingCardsAdd] = useState(false)
  const [skillServices, setSkillServices] = useState([])
  const [allProducts, setAllproducts] = useState([])
  const [materials, setAllMaterials] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [requestTeam, setRequestTeam] = useState([])
  const [openPreview, setOpenPreview] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedMaterials, setSelectedMaterials] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([],)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [location, setLocation] = useState(false)
  const [projectTypes, setProjectTypes] = useState([])
  const [workflow, setWorkFlow] = useState([])
  const [projectCategories, setProjectCategories] = useState([])
  const [noChargeType, setNoChargeType] = useState([])
  const [communities, setCommunities] = useState([])
  const [isCommunityLoading, setIsCommunityLoading] = useState(false)
  const [locationStates, setLocationStates] = useState({})
  const [serviceOnlyLocationStates, setServiceOnlyLocationStates] = useState({})
  const [rfpLocationStates, setRfpLocationStates] = useState({})
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({})
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [allServiceLocationSame, setAllServiceLocationSame] = useState(false)
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] = useState(false)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] = useState(false)
  const [address, setAddress] = useState({ 23: [{ 0: { address: 'addd', city: 'fsdasadf', state: 'fsd', zip: 1654 } }], }) // 23:[{address:'sdfsdf',city:'fsdasadf',state:'fsd',zip:1654}]
  const [progress, setProgress] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().unix())
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [otherInstallationProducts, setOtherInstallationProducts] = useState([])
  const [incomingSplitMarkup, setIncomingSplitMarkup] = useState(0)
  const [splitPercentage, setSplitPerscentage] = useState(0)
  const [splitManagementSettings, setSplitManagementSettings] = useState([])
  const [filtersApplied, setFiltersApplied] = useState(false)
  const [isDeletingFilters, setIsDeletingFilters] = useState(false)
  const [filtersInitialized, setFiltersInitialized] = useState(false)
  const didRunInitialFiltersSyncRef = useRef(false)
  const [billingTypes, setBillingTypes] = useState([]);


  let user = JSON.parse(localStorage.getItem('user'))
  let isClient = user?.isClient
  let userType = isClient ? 3 : user.user_type
  let userId = user.user_id
let teamId = user?.team_id? user.team_id : null
  if (user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  const explodedPermissions = user?.exploded_permissions
      const hasPermission = (incommingPermission) => {
      return explodedPermissions?.some(permission => [incommingPermission].includes(permission)) ? true : false
    }
  const hasMarkupPermission = explodedPermissions?.some((permission) => ['View Markup'].includes(permission),)
    ? true
    : false
  const hasDiscountPermission = explodedPermissions?.some((permission) => ['Manage Discount'].includes(permission),)
    ? false
    : true
  const hasViewCostPermission = hasPermission('View Sales Order Cost')
    
  const refCommunities = useRef(null)
  const refClients = useRef(null)
  const refUsers = useRef(null)
  const refSettings = useRef(null)
  const [allClients, setAllClients] = useState([])
  const [communitiesOpen, setCommunitiesOpen] = useState(false)
  const [clientsOpen, setClientsOpen] = useState(false)
  const [usersOpen, setUsersOpen] = useState(false)
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null)
  const isFiltersOpen = Boolean(filtersAnchorEl)
  const [communitiesData, setCommunitiesData] = useState([])
  const [clientData, setClientData] = useState([])
  const [userData, setUserData] = useState([])
  const [filterCommunity, setFilterCommunity] = useState([])
  const [filterClient, setFilterClient] = useState([])
  const [filterUser, setFilterUser] = useState([])
  const [clientSearchTerm, setClientSearchTerm] = useState('')
  const [userSearchTerm, setUserSearchTerm] = useState('')
  const [projectSearchTerm, setProjectSearchTerm] = useState('')
  const [markupType, setMarkupType] = useState(2)
  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('id')
  const [showServices, setShowServices] = useState(false)
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false),)
  const [currentTab, setCurrentTab] = useState(newTab || 'ALL')
  const [indexCounter, setIndexCounter] = useState(0)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const [rfps, setRfps] = useState([]) // List of RFPs
  const [selectedRfp, setSelectedRfp] = useState(null) // Selected RFP
  const [openModal, setOpenModal] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)
  const [rfpServices, setRfpServices] = useState([])
  const [rfpProducts, setRfpProducts] = useState([])
  const [cart, setCart] = useState([])
  const [cartService, setCartService] = useState([])
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [filterDateValue, setFilterDateValue] = useState([null, null])
  const [sort, setSort] = useState(SORT[0])
  const [sortOpen, setSortOpen] = useState(false)
  const [noCharge, setNoCharge] = useState(false)
  const refSort = useRef(null)
  const paginationScrollAnchorRef = useRef(null)
  const skipPaginationScrollRef = useRef(true)
  const prevLoadingCardsForPaginationScrollRef = useRef(loadingCards)
  const [openProductNote, setOpenProductNote] = useState({})
  const [openServiceNote, setOpenServiceNote] = useState({})
  const [isSavingNote, setIsSavingNote] = useState(false)
  const [currentNote, setCurrentNote] = useState('')
  const [selectedTaxCategory, setSelectedTaxCategory] = useState(null)
  const [taxCategories, setTaxCategories] = useState([])
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [allId, setAllId] = useState([])
  const [mapServices, setMapServices] = useState([])
  const [mapServicesLoading, setMapServicesLoading] = useState(false)
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState([],)
  const [dueData, setDueData] = useState(true)
  const [skipFetch, setSkipFetch] = useState(false)
  const [newValues, setNewValues] = useState(null)

  const [newTotalAmount, setNewTotalAmount] = useState(0);
  const [newTotalMarkup, setNewTotalMarkup] = useState(0);
  const [newTotalProductFormula, setNewTotalProductFormula] = useState(0);
  const [newTotalWholesalePrice, setNewTotalWholesalePrice] = useState(0);
  const [newTotalRetailPrice, setNewTotalRetailPrice] = useState(0);
  const [newOriginalTotalMarkup, setNewOriginalTotalMarkup] = useState(0);
  const [newOriginalTotalServiceMarkup, setNewOriginalTotalServiceMarkup] = useState(0);
  const [newTotalServiceMarkup, setNewTotalServiceMarkup] = useState(0);
  const [newTotalDiscount, setNewTotalDiscount] = useState(0);
  const [newDiscountTotal, setNewDiscountTotal] = useState(0);
  const [newTotalJobcostSum, setNewTotalJobcostSum] = useState(0);
  const [newTotalsum, setNewTotalsum] = useState(0);
  const [newGrandTotal, setNewGrandTotal] = useState(0);
  const openSalesOrderTemp = localStorage.getItem('salesOrderOpenPopup')
  const [opeSalesOrder, setOpenSalesOrder] = useState(openSalesOrderTemp || false)
  const [SalesOrderId, setSalesOrderId] = useState('')
  const [salesOrderName, setSalesOrderName] = useState('')
  const [salesOrderCombineGrouped, setSalesOrderCombineGrouped] = useState(false)
  const [renderCard, setRenderCard] = useState(false)
  const [filterProjectType, setFilterProjectType] = useState('ALL');
  const [valueTab, setTabValue] = useState('one')
  const [filterProjectCategory, setFilterProjectCategory] = useState('ALL');
  const [selectedInvoiceGroupIds, setSelectedInvoiceGroupIds] = useState([])
  const [groupingInvoiceRequests, setGroupingInvoiceRequests] = useState(false)
  const [groupedInvoiceDialog, setGroupedInvoiceDialog] = useState({
    open: false,
    card: null,
  })
  const [selectedGroupedUngroupIds, setSelectedGroupedUngroupIds] = useState([])
  const [ungroupingInvoiceRequests, setUngroupingInvoiceRequests] = useState(false)


 const [openEmailModal,setOpenEmailModal] = useState(false)
 const viewasadmin =explodedPermissions?.some(permission => ['View Sales Order as Admin'].includes(permission)) ? true : false
 console.log('viewasadmin', viewasadmin)

  // Fetch view type from backend
  const fetchViewType = async () => {
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      const res = await axios.post(`${REST_API_END_POINT}get-official-request-view-type`, { userId });
      if (res.data?.status === 1 && res.data?.data?.viewType !== undefined) {
        const viewType = res.data.data.viewType;
        setTabValue(viewType);
        // Set dueData based on tab selection
        if (viewType === 'two' || viewType === 'three') {
          setDueData(false);
        } else {
          setDueData(true);
        }
      }
    } catch (error) {
      console.error('Error fetching view type:', error);
    }
  };
  
  // Load view type from backend on mount
  useEffect(() => {
    fetchViewType();
  }, []);

  // Persist Official Request filters (clients, users, projects, dates, sort, dueData) to shared preferences
  useEffect(() => {
    if (!filtersInitialized) return;

    // Skip calling update-project-filters once right after initial load
    if (!didRunInitialFiltersSyncRef.current) {
      didRunInitialFiltersSyncRef.current = true;
      return;
    }

    // While deleting filters, don't sync to backend
    if (isDeletingFilters) return;

    if (!userId) return;

    const timeoutId = setTimeout(async () => {
      try {
        await axios.post(`${REST_API_END_POINT}update-project-filters`, {
          userId,
          teamFilter: [], // not used on Official Request currently
          clientFilter: filterClient || [],
          communityFilter: filterCommunity || [],
          userFilter: filterUser || [],
          jobClassFilter: [], // not used on Official Request currently
          jobTypeFilter: [],  // not used on Official Request currently
          projectTypeFilter: filterProjectType,
          dueFilter: dueData ? 1 : 0,
          sortFilter: sort?.id || (SORT[0]?.id || 'new'),
          fromDate: filterDateValue[0]
            ? Math.floor(filterDateValue[0].getTime() / 1000)
            : null,
          toDate: filterDateValue[1]
            ? Math.floor(filterDateValue[1].getTime() / 1000)
            : null,
          pageKey:splitOrder ? 'request-split' : 'request',
        });
      } catch (error) {
        console.error('Error saving request filters:', error);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    userId,
    filterClient,
    filterUser,
    filterCommunity,
    splitOrder,
    filterProjectType,
    dueData,
    sort,
    filterDateValue,
    filtersInitialized,
  ]);

  // Update "filtersApplied" immediately when filters change
  useEffect(() => {
    const hasActiveFilters =
      (filterClient && filterClient.length > 0) ||
      (filterCommunity && filterCommunity.length > 0) ||
      (filterUser && filterUser.length > 0) ||
      filterProjectType !== 'ALL' ||
      filterProjectCategory !== 'ALL' ||
      !dueData ||
      sort?.id !== SORT[0]?.id ||
      !!filterDateValue?.[0] ||
      !!filterDateValue?.[1];

    setFiltersApplied(hasActiveFilters);
  }, [
    filterClient,
    filterCommunity,
    filterUser,
    filterProjectType,
    filterProjectCategory,
    dueData,
    sort,
    filterDateValue,
  ]);

  const handleChangeGrid = async (event, newValue) => {
    setTabValue(newValue);
    // Set dueData based on tab selection
    if (newValue === 'two' || newValue === 'three') {
      setDueData(false);
    } else {
      setDueData(true);
    }
    
    // Save view type to backend
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      await axios.post(`${REST_API_END_POINT}update-official-request-view-type`, { userId, viewType: newValue });
    } catch (error) {
      console.error('Error updating view type:', error);
    }
  };

  const removePopupData = () => {
    setSalesOrderId('')
    setSalesOrderName('')
    setSalesOrderCombineGrouped(false)
    localStorage.removeItem('salesOrderCombineGrouped')
  }

  const salesOrderSkipRibbonDismissKey = (orderId) => `salesOrderSkipRibbonDismiss_${orderId}`

  const dismissSalesOrderNewTag = async (id) => {
    setAllRequest((prev) =>
      (prev || []).map((row) =>
        row.id === id ? { ...row, is_new_in_tab: false } : row,
      ),
    )
    try {
      await axios.post(`${REST_API}webservice/sales-order/reduce-tabs-count`, {
        request_id: id,
        userId,
      })
    } catch (error) {
      console.error('Error clearing sales order new tag:', error)
    }
  }
  const [isEditSalesOrder, setIsEditSalesOrder] = useState('')
  const handleOpenViewSalesOrder = (id, name, isCreation = false) => {
    if (isCreation) {
      sessionStorage.setItem(salesOrderSkipRibbonDismissKey(id), '1')
    } else {
      dismissSalesOrderNewTag(id)
    }
    setIsEditSalesOrder(true)
    setSalesOrderId(id)
    setSalesOrderName(name)
    setSalesOrderCombineGrouped(false)
    setOpenSalesOrder(true)
    localStorage.setItem('salesOrderProjectId', id);
    localStorage.setItem('salesOrderProjectName', name);
    localStorage.setItem('isEditSalesOrder', "true");
    localStorage.setItem('salesOrderOpenPopup', 'true');
    localStorage.setItem('salesOrderCombineGrouped', 'false');

  }
  const handleOpenDetailsSalesOrder = (id, name, isCreation = false, combineGroupedInvoice = false) => {
    if (isCreation) {
      sessionStorage.setItem(salesOrderSkipRibbonDismissKey(id), '1')
    } else {
      dismissSalesOrderNewTag(id)
    }
    setIsEditSalesOrder(false)
    setSalesOrderId(id)
    setSalesOrderName(name)
    setSalesOrderCombineGrouped(!!combineGroupedInvoice)
    setOpenSalesOrder(true)
    localStorage.setItem('salesOrderProjectId', id);
    localStorage.setItem('salesOrderProjectName', name);
    localStorage.setItem('isEditSalesOrder', "false");
    localStorage.setItem('salesOrderOpenPopup', 'true');
    localStorage.setItem('salesOrderCombineGrouped', combineGroupedInvoice ? 'true' : 'false');
  }

  const fetchRequestFilters = async () => {
    try {
      await axios
        .post(`${REST_API}webservice/request/get-all-request-filters`, {
          userType: userType,
          userId: userId,
        })
        .then((res) => {
          const othersCommunity = { id: 'other', name: 'Others' }

          let communitiesData = res.data.community || []
          if (res.data?.community) {
            communitiesData = communitiesData.map((community) => ({
              ...community,
              checked: filterCommunity.includes(community.id),
            }))
            setCommunitiesData([...communitiesData])
          } else {
            setCommunitiesData([othersCommunity])
          }

          let clientData = res.data.clients || []
          if (res.data?.clients) {
            clientData = clientData.map((client) => ({
              ...client,
              checked: filterClient.includes(client.id),
            }))
            setClientData([...clientData])
          } else {
            setClientData([])
          }

          if (res.data?.staffMembers) {
            const staffData = res.data.staffMembers.map((staff) => ({
              ...staff,
              checked: filterUser.includes(staff.id),
            }))
            setUserData([...staffData])
          } else {
            setUserData([])
          }
        })
        .catch((errors) => {
          console.log(errors, 'error in fetching request filters')
        })
    } catch (error) {
      console.log('fetchRequestFilters error : ', error)
    }
  }

  let totalAmount = 0;
  let totalMarkup = 0;
  let totalProductFormula = 0;
  let totalWholesalePrice = 0;
  let totalRetailPrice = 0;
  let originaltotalMarkup = 0;
  let originaltotalServiceMarkup = 0;
  let totalServiceMarkup = 0;
  let totalDiscount = 0;
  let DiscountTotal = 0;
  let totalJobcostSum = 0;
  let totalsum = 0;
  let grandTotal = 0;

  const handleByDue = () => {
    setDueData(!dueData)
  }

  const handleOpenFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget)
  }

  const handleCloseFilters = () => {
    setFiltersAnchorEl(null)
    setCommunitiesOpen(false)
    setClientsOpen(false)
    setUsersOpen(false)
    setSortOpen(false)
  }

  // const [userId, setUserId] = useState(() => {
  //   const storedUser = JSON.parse(localStorage.getItem('user'));
  //   return storedUser ? storedUser.user_id : null;
  // });

  const VALUE = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    //  { id: 4, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 5, value: 'Product formula cost' },
    {
      id: 6,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    {
      id: 7,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 8, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 9, value: 'Unit' },
    { id: 10, value: 'Quantity' },
    { id: 11, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 12, value: 'Marketing Adjustment ' },
    // { id: 12, value: 'Discount' },
    { id: 13, value: 'Subtotal' },
    { id: 15, value: '' },
  ]
  const VALUE_TIME = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    { id: 4, value: 'Selling Price (per product)' },
    { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    { id: 7, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 8, value: 'Marketing Adjustment ' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]
  const VALUE_TIME_Preview = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    // { id: 3, value: 'Note' },
    { id: 4, value: 'Selling Price (per product)' },
    { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    // { id: 7, value: 'Location' },
    { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]
  const VALUE_MATERIAL = [
    { id: 0, value: 'Material' },
    { id: 1, value: 'Unit Price' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Markup Cost (Unit)' },
    { id: 4, value: 'Quantity' },
    { id: 5, value: 'Product Formula Cost' },
    { id: 6, value: 'Total' },
    { id: 7, value: '' },
  ]
  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products & Notes' },
    // { id: 2, value: 'Product formula cost' }, // (Material cost + Service cost with markup)
    {
      id: 3,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    {
      id: 4,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: 'Unit  ' },
    { id: 7, value: 'Quantity' },
    { id: 8, value: 'Marketing Adjustment' },
    // { id: 8, value: 'Discount' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Cost (Hourly)' },
    { id: 4, value: 'Markup Cost (Hourly)' },
    { id: 5, value: 'Hours' },
    { id: 6, value: 'Location' },
    { id: 7, value: 'Product Formula Cost' },
    { id: 8, value: 'Additional Cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' },
  ]
  const VALUE_RFP_Product = [
    { id: 0, value: ' Name' },
    { id: 1, value: 'Mark Up' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Selling Price' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    { id: 6, value: 'Product Formula Cost' },
    { id: 7, value: 'Total' },
    { id: 8, value: '' },
    { id: 9, value: '' },
  ]
  const VALUE_RFP = [
    { id: 0, value: ' Name' },
    { id: 1, value: 'Markup (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Markup Cost (Hourly)' },
    { id: 4, value: 'Hours' },
    { id: 5, value: 'Total cost' },
    { id: 6, value: '' },
    { id: 7, value: '' },
  ]
  // const [expandedCommunities, setExpandedCommunities] = useState({});

  // const handleExpandToggle = (community) => {
  //   setExpandedCommunities(prevState => ({
  //     ...prevState,
  //     [community]: !prevState[community]
  //   }));
  // };

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }))
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    color: theme.palette.text.secondary,
  }))
  const load = useLocation().state

  const fetchSalesOrderTabGlowFlags = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/sales-order/sales-order-tabs-count`, { userId })
      if (res.data?.status === 1 && res.data?.tabGlowFlags) {
        setTabGlowFlags(res.data.tabGlowFlags)
      }
    } catch (error) {
      console.error('Error fetching sales order tab glow flags:', error)
    }
  }

  const clearSalesOrderTabGlowOnTabOpen = async (tabName) => {
    if (!tabName || tabName === 'ALL') return
    try {
      const res = await axios.post(`${REST_API}webservice/sales-order/clear-tab-glow`, {
        userId,
        tabName,
      })
      if (res.data?.tabGlowFlags) {
        setTabGlowFlags(res.data.tabGlowFlags)
      } else {
        setTabGlowFlags((prev) => ({ ...prev, [tabName]: 0 }))
      }
    } catch (error) {
      console.error('Error clearing sales order tab glow:', error)
      setTabGlowFlags((prev) => ({ ...prev, [tabName]: 0 }))
    }
  }

  const buildInvoicingTabWhereCondition = (splitOrderCond) => `(
    (
      (r.for_parent_facility = 2 AND r.status = 4 AND r.split_mirror_status = 4)
      OR (
        (proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND r.noServiceNoTask = 0 AND r.status = 4)
        OR (
          i.status IS NOT NULL
          AND (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
          AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        )
      )
      AND r.installation_acceptance IS NULL
      AND r.isReview != 2
    )
    AND (COALESCE(i.pending_review, 0) = 0)
    AND (r.split_mirror_status != 8 AND r.split_mirror_status != 1 AND r.split_mirror_status != 2 AND r.split_mirror_status != 3 AND r.split_mirror_status != 5 AND r.received_status != 1)
    AND COALESCE(r.is_grouped_request, 0) != 2
    AND r.hold=0 AND ${splitOrderCond}
  )
  OR (
    r.is_grouped_request = 1
    AND r.installation_acceptance IS NULL
    AND r.hold=0 AND ${splitOrderCond}
  )`

  const excludeGroupedChildSalesOrders = 'COALESCE(r.is_grouped_request, 0) != 2'

  const buildAllTabWhereCondition = (splitOrderCond, options = {}) => {
    const {
      isClientUser = false,
      includeStatusFilter = false,
      skipArchiveExclusion = false,
    } = options
    if (isClientUser) {
      const statusFilter = includeStatusFilter ? ' r.status NOT IN (0, 1, 8) AND' : ''
      const archiveFilter = skipArchiveExclusion
        ? ''
        : ' AND NOT (r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60))'
      return `${statusFilter} r.isReview != 2 AND quotation = 0${archiveFilter} AND ${excludeGroupedChildSalesOrders} AND ${splitOrderCond} `
    }
    return ` NOT ( COALESCE(r.installation_acceptance, 0) = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60) ) AND ${excludeGroupedChildSalesOrders} AND ${splitOrderCond} `
  }

  const applyTabTotalCount = (response, tab) => {
    const count = Number(response?.data?.data?.totalCount)
    if (!Number.isFinite(count) || count < 0) return
    setTotalCount(count)
    if (tab === 'INVOICING' || tab === 'REVIEW') {
      setInvoiceCount(count)
    }
  }

  const handleSearchingChange = (value) => {
    setPage(0)
    setSearching(value)
  }

  //get All request
  const fetchAllRequest = async () => {
    setLoadingCards(true)
    // setLoadingCardsAdd(true)
    try {
      let user = JSON.parse(localStorage.getItem('user'))
 const splitOrderCondition = splitOrder ? "r.is_split_order = 1" : "r.is_split_order = 0";


      let whereCondition = ''
      if (currentTab == 'NEW') {
        whereCondition = ` r.new_order = 1  AND r.quotation = 0 AND r.hold=0 AND ${splitOrderCondition} `
      }else if (currentTab == 'AWAITING APPROVAL') {
        whereCondition = ` ((r.status=2) OR (r.status=3 AND r.min_payment_status=0) OR (r.split_mirror_status = 7 AND r.status = 3))AND r.hold=0 AND r.new_order = 0 AND ${splitOrderCondition} `
      } else if (currentTab == 'HOLD') {
        whereCondition = ` r.hold =1 AND r.status != 6 AND ${splitOrderCondition} ` // r.status=4 OR
      } else if (currentTab == 'ACCEPTED') {
        whereCondition = ` (r.status=3 AND r.min_payment_status =1 AND r.hold=0 AND r.new_order = 0 AND r.split_mirror_status = 0 AND (r.manager_approval_required=0 OR r.send_to_client=1)) AND ${splitOrderCondition} ` // r.status=4 OR
      }
      else if (currentTab == 'REJECTED') {
        whereCondition = ` r.status = 6 AND ${splitOrderCondition} `
      }
      else if (currentTab == 'NO SERVICE NO TASK') {
        whereCondition = ` r.noServiceNoTask = 1 AND r.status=4 and i.status IS NULL and proj.status = 3 AND r.hold=0 AND ${splitOrderCondition}  `
      } else if (currentTab == 'IN PRODUCTION') {
        whereCondition = ` ((r.status=4 and proj.status <> 3 AND r.hold=0 AND r.new_order = 0 ) OR (r.for_parent_facility = 2 AND r.status = 4 AND r.received_status = 0)) AND (r.split_mirror_status = 0 OR r.split_mirror_status = 6 OR r.split_mirror_status = 8) AND ${splitOrderCondition} `
      } else if (currentTab == 'INSTALLATION') {
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 1
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 1 AND inst_tab.status != 0) AND r.status != 3 AND proj.status = 3 AND
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
      )
      OR
      (
        r.status = 4
        AND r.received_status = 1
        AND r.split_mirror_status = 1
      )
      OR
      (
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        AND COALESCE(i.pending_review, 0) = 1
        AND r.installation_acceptance IS NULL
      )
      OR
      (
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        AND COALESCE(i.pending_review, 0) = 2
        AND r.installation_acceptance IS NULL
      )
      )
              AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition = `
        //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 1 AND 
        //   (
        //     (r.project_category = 12 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 11 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 14 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category NOT IN (11, 12, 14) AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0))
        //   )
        // `
      }
      else if (currentTab == 'RETURNED') {
        whereCondition = `
        i.status IS NOT NULL AND i.status = 5 AND i.complete_status IN (1,2,3) AND i.status != 0 AND r.status != 3 AND
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
              AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (currentTab == 'PICKUP') {
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 2
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 2) AND r.status != 3 AND proj.status = 3 AND 
          (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
      )
      OR
      (
        r.status = 4
        AND r.received_status = 1
        AND r.split_mirror_status = 2
      )
      )
            AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition = `
        //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 2 AND 
        //   (
        //     (r.project_category = 12 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 11 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 14 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category NOT IN (11, 12, 14) AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0))
        //   )
        // `
      } else if (currentTab == 'SHIPPING') {
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 3
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 3) AND r.status != 3 AND proj.status = 3 AND 
          (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        )
        OR
        (
          r.status = 4
          AND r.received_status = 1
          AND r.split_mirror_status = 3
        )
        )
            AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition= `
        //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 3 AND 
        //   (
        //     COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
        //     OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //     OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //   )
        // `
      } else if (currentTab == 'COMPLETED') {
        // whereCondition = ` i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) AND r.installation_acceptance IS NOT NULL  `
        whereCondition = `
        ((r.for_parent_facility = 2 AND r.status = 4 AND r.split_mirror_status = 5) OR
        ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
        AND r.installation_acceptance IS NOT NULL
        AND NOT (r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)))
        AND COALESCE(r.is_grouped_request, 0) != 2
        AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition =  `
        //   i.status IS NOT NULL AND 
        //   (
        //     (r.project_category = 12 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 11 AND inst_counts.installation_count >= COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 14 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category NOT IN (11, 12, 14) AND inst_counts.installation_count >= COALESCE(cop.product_count, 0))
        //   ) 
        //   AND r.installation_acceptance IS NOT NULL
        // `
      } else if (currentTab == 'REVIEW') {
        // whereCondition = `i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) AND r.installation_acceptance IS NULL `
        whereCondition = `
      ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
      (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
    AND r.installation_acceptance IS NULL AND r.isReview =2
    AND r.hold=0 AND ${splitOrderCondition} 
  `
      } else if (currentTab == 'ALL') {
        whereCondition = buildAllTabWhereCondition(splitOrderCondition, {
          isClientUser: isClient || userType === 3,
        })
      }
      else if (currentTab == 'INVOICING') {
        whereCondition = buildInvoicingTabWhereCondition(splitOrderCondition)
        //       whereCondition = `
        //   i.status IS NOT NULL AND 
        //   (
        //     (r.project_category = 12 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 11 AND inst_counts.installation_count >= COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 14 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (inst_counts.installation_count >= COALESCE(cop.product_count, 0))
        //   ) 
        //   AND r.installation_acceptance IS NULL
        // `
      } else if (currentTab == 'ARCHIVE') {
        whereCondition = `
        r.installation_acceptance IS NOT NULL AND r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)
        AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (currentTab == 'VOID') {
        whereCondition = ` r.status = 10 AND r.quotation = 0 AND ${splitOrderCondition} `
      }

      const formattedFrom = filterDateValue[0]
        ? moment(filterDateValue[0]).format('YYYY-MM-DD HH:mm:ss')
        : null
      const formattedTo = filterDateValue[1]
        ? moment(filterDateValue[1]).format('YYYY-MM-DD HH:mm:ss')
        : null

      const values = {
        userType: viewasadmin ? 1 : userType,
        userId: userId,
        page: page + 1,
        rowsPerPage,
        search: searching,
        where: whereCondition,
        sort: sort.id,
        from: formattedFrom,
        to: formattedTo,
        filterCommunity: filterCommunity,
        filterClient: filterClient,
        filterUser: filterUser,
        filterProjectType: filterProjectType,
        dueData: dueData,
        filterProjectCategory:filterProjectCategory,
        currentTab,
      }
      await axios
        .post(`${REST_API}webservice/request/get-all-request-new`, values)
        .then((res) => {
          res.data.data

          setAllRequest(res.data?.data?.data || [])
          applyTabTotalCount(res, currentTab)
          // if (res?.data?.data?.totalCount) {
          //   setTotalCount(res?.data?.data?.totalCount)
          // } else {
          //   setTotalCount(0)
          // }
          console.log('hbafdhbsidhfbhsdbfi', searching !== '')
          console.log('hbafdhbsidhfbhsdbfi', searching.length)

          if (currentTab == 'ALL' && searching !== '') {
            setAllCount(res?.data?.data?.totalCount || 0)
          } else {
            setAllCount(res?.data?.data?.allCount || 0)
          }
          fetchSalesOrderTabGlowFlags()
          // if (currentTab == 'AWAITING APPROVAL') {
          //   setOpenCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setOpenCount(res?.data?.data?.openCount || 0)
          // }
          // if (currentTab == 'ACCEPTED') {
          //   setAcceptedCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setAcceptedCount(res?.data?.data?.acceptedCount || 0)
          // }
          // if (currentTab == 'IN PRODUCTION') {
          //   setinProductionCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setinProductionCount(res?.data?.data?.inProductionCount || 0)
          // }
          // if (currentTab == 'INSTALLATION') {
          //   setInstallsCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setInstallsCount(res?.data?.data?.installsCount || 0)
          // }
          // if (currentTab == 'PICKUP') {
          //   setPickupCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setPickupCount(res?.data?.data?.pickupCount || 0)
          // }
          // if (currentTab == 'SHIPPING') {
          //   setShippingCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setShippingCount(res?.data?.data?.shippingCount || 0)
          // }
          // if (currentTab == 'COMPLETED') {
          //   setCompletedCount(res?.data?.data?.totalCount || 0)
          // } else {
          //   setCompletedCount(res?.data?.data?.completedCount || 0)
          // }

        })
        .catch((errors) => {
          console.log(errors, 'error in fetching all requests')
        })
    } catch (error) {
      console.log('fetchAllRequest error : ', error)
    } finally {
      setLoadingCards(false)
    }
  }
  const fetchAllRequestNew = async () => {
    setLoadingCardsAdd(true)
    try {
      let user = JSON.parse(localStorage.getItem('user'))

      const splitOrderCondition = splitOrder ? "r.is_split_order = 1" : "r.is_split_order = 0";
      let whereCondition = ''
      if (currentTab == 'NEW') {
        whereCondition = ` r.new_order = 1  AND r.quotation = 0 AND r.hold=0 AND ${splitOrderCondition} `
      }else if (currentTab == 'AWAITING APPROVAL') {
        whereCondition = ` ((r.status=2) OR (r.status=3 AND r.min_payment_status=0) OR (r.split_mirror_status = 7 AND r.status = 3) OR (r.status=3 AND r.manager_approval_required=1 AND r.send_to_client=0)) AND r.hold=0 AND r.new_order = 0 AND ${splitOrderCondition} `
      }else if (currentTab == 'HOLD') {
        whereCondition = ` r.hold =1 AND r.status != 6 AND ${splitOrderCondition} ` // r.status=4 OR
      } else if (currentTab == 'ACCEPTED') {
        whereCondition = ` (r.status=3 AND r.min_payment_status =1 AND r.hold=0 AND r.new_order = 0 AND (r.manager_approval_required=0 OR r.send_to_client=1)) AND r.split_mirror_status = 0 AND ${splitOrderCondition} ` // r.status=4 OR
      }
      else if (currentTab == 'REJECTED') {
        whereCondition = ` r.status = 6 AND ${splitOrderCondition} `
      }
      else if (currentTab == 'NO SERVICE NO TASK') {
        whereCondition = ` r.noServiceNoTask = 1 AND r.status=4 and i.status IS NULL and proj.status = 3 AND r.hold=0 AND ${splitOrderCondition} `
      } else if (currentTab == 'IN PRODUCTION') {
        whereCondition = ` ((r.status=4  and proj.status <> 3 AND r.hold=0 AND r.new_order = 0) OR (r.for_parent_facility = 2 AND r.status = 4 AND r.received_status = 0) ) AND (r.split_mirror_status = 0 OR r.split_mirror_status = 6 OR r.split_mirror_status = 8) AND ${splitOrderCondition} `
      } else if (currentTab == 'INSTALLATION') {
        // whereCondition = ` i.status IS NOT NULL AND ( COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) OR (pc.name = 'Service only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) ) `
        // whereCondition = ` i.status IS NOT NULL AND i.status != 4 AND i.status != 5 AND  i.complete_status = 1 AND ( 
        //   COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
        //   OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //   OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        // ) `
        whereCondition = `
        ((
        r.for_parent_facility = 2 
        AND r.status = 4
        AND r.split_mirror_status = 1
      )
        OR
      ( 
      EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 1 AND inst_tab.status != 0) AND r.status != 3 AND proj.status = 3 AND
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
          AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
      ))
      OR
      (
        r.status = 4
        AND r.received_status = 1
        AND r.split_mirror_status = 1
      )
      OR
      (
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        AND COALESCE(i.pending_review, 0) = 1
        AND r.installation_acceptance IS NULL
      )
      OR
      (
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        AND COALESCE(i.pending_review, 0) = 2
        AND r.installation_acceptance IS NULL
      )
      ) AND r.hold=0 AND ${splitOrderCondition} 
      `
    //     whereCondition = `
    //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 1 AND 
    //   (
    //     (r.project_category = 12 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
    //     (r.project_category = 11 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) OR
    //     (r.project_category = 14 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
    //     (r.project_category NOT IN (11, 12, 14) AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0))
    //   )
    // `
      }
      else if (currentTab == 'RETURNED') {
        whereCondition = `
        i.status IS NOT NULL AND i.status = 5 AND i.complete_status IN (1,2,3) AND i.status != 0 AND r.status != 3 AND
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
              AND r.hold=0 AND ${splitOrderCondition} 
      `
      }
      else if (currentTab == 'PICKUP') {
        // whereCondition = ` i.status IS NOT NULL AND ( COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) OR (pc.name = 'Service only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) ) `
        // whereCondition = ` i.status IS NOT NULL AND i.status != 5 AND i.status != 4 AND i.complete_status = 2 AND ( 
        //   COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
        //   OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //   OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        // ) `
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 2
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 2) AND r.status != 3 AND proj.status = 3 AND 
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
          AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        ))
          AND r.hold=0 AND ${splitOrderCondition} 
      `
    //     whereCondition = `
    //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 2 AND 
    //   (
    //     (r.project_category = 12 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
    //     (r.project_category = 11 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) OR
    //     (r.project_category = 14 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
    //     (r.project_category NOT IN (11, 12, 14) AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0))
    //   )
    // `
      } else if (currentTab == 'SHIPPING') {
        // whereCondition = ` i.status IS NOT NULL AND ( COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) OR (pc.name = 'Service only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) ) `
        //previos
        // whereCondition = ` i.status IS NOT NULL  AND i.status != 5 AND i.complete_status = 3 AND ( 
        //   COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
        //   OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //   OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        // ) `
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 3
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 3) AND r.status != 3 AND proj.status = 3 AND 
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        ))
            AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition= `
        //   i.status IS NOT NULL AND i.status != 5 AND i.complete_status = 3 AND 
        //   (
        //     COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) 
        //     OR (pc.name = 'Service Only' AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //     OR (COALESCE(cop.product_count, 0) = 0 AND COALESCE(rss.service_count, 0) > 0 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0))
        //   )
        // `
      } else if (currentTab == 'COMPLETED') {
        // whereCondition = ` i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) `
        whereCondition = `
        ((r.for_parent_facility = 2 AND r.status = 4 AND r.split_mirror_status = 5) OR
        ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
          (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
        AND r.installation_acceptance IS NOT NULL
        AND NOT (r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)))
        AND r.hold=0 AND ${splitOrderCondition} 
      `
        //   whereCondition =  `
        //   i.status IS NOT NULL AND 
        //   (
        //     (r.project_category = 12 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 11 AND inst_counts.installation_count >= COALESCE(rss.service_count, 0)) OR
        //     (r.project_category = 14 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
        //     (r.project_category NOT IN (11, 12, 14) AND inst_counts.installation_count >= COALESCE(cop.product_count, 0))
        //   ) 
        //   AND r.installation_acceptance IS NOT NULL
        // `
      } else if (currentTab == 'ALL') {
        whereCondition = buildAllTabWhereCondition(splitOrderCondition, {
          isClientUser: isClient || userType === 3,
          skipArchiveExclusion: true,
        })
      }

      const formattedFrom = filterDateValue[0]
        ? moment(filterDateValue[0]).format('YYYY-MM-DD HH:mm:ss')
        : null
      const formattedTo = filterDateValue[1]
        ? moment(filterDateValue[1]).format('YYYY-MM-DD HH:mm:ss')
        : null

      const values = {
        userType: viewasadmin ? 1 : userType,
        userId: userId,
        page: page + 1,
        rowsPerPage,
        search: searching,
        where: whereCondition,
        sort: sort.id,
        from: formattedFrom,
        to: formattedTo,
        filterCommunity: filterCommunity,
        filterClient: filterClient,
        filterUser: filterUser,
        filterProjectType: filterProjectType,
        dueData: dueData,
        filterProjectCategory: filterProjectCategory,
        isSplitOrder: splitOrder,
      }
      // Replaced: webservice/request/get-all-request -> webservice/request/get-all-request-for-add
      await axios
        .post(`${REST_API}webservice/request/get-all-request-for-add`, values)
        .then((res) => {
          // res.data.data
          // console.log('reeeeeeeeeeeee', res.data.data)

          // const ids = res?.data?.data.data.map((item) => item.id)
          // setAllId(ids)

          setRequestTeam(res.data.requestTeam)
          setSkillServices(res.data.services)
          setWorkFlow(res.data.workflows)

          // setAllproducts(res.data.products)
          // setOtherInstallationProducts(res.data.otherInstallationProducts)
          let currentInstallationProductData = res?.data?.products
          let otherInstallationProductData = res?.data?.otherInstallationProducts
          let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
          setAllproducts(combinedProducts)

          let incomingSplitMarkup = res?.data?.currentFacilitySplitManagementSettings?.find(setting => setting?.is_default)?.incoming_percentage
          setIncomingSplitMarkup(incomingSplitMarkup)
          setSplitManagementSettings(res?.data?.otherInstallationSplitManagementSettings)

          // setAllMaterials(res.data.materials)  15-01-25 previos
          //new
          const allMatData = Array.isArray(res.data.materials)
            ? res.data.materials.map((material) => ({
              ...material,
              markup: Number(material.retail_price || 0),
            }))
            : []
          console.log('allMatData---1', allMatData)
          setAllMaterials(allMatData?.filter(item => item.isAdditionalProduct == 0))

          let currentInstallationServiceData = res?.data?.labourCostServices
          let otherInstallationServiceData = res?.data?.otherInstallationServices
          let combinedServices = [...(currentInstallationServiceData || []), ...(otherInstallationServiceData || [])];
          setLabourCostServices(combinedServices)
          setRfps(res.data.allProposals)
          setFilteredServices(combinedServices)
          setBillingTypes(res.data.billingTypes)

          // const othersCommunity = { id: 'other', name: 'Others' }
          // let communitiesData = res.data.community || []
          // // const othersClient = { id: 'other', name: 'Others' }
          // let clientData = res.data.clients || []
          // if (res.data?.community) {
          //   // setCommunitiesData([...res.data.community, othersCommunity]);
          //   communitiesData = communitiesData.map((community) => ({
          //     ...community,
          //     checked: filterCommunity.includes(community.id),
          //   }))

          //   setCommunitiesData([...communitiesData]) //othersCommunity
          // } else {
          //   setCommunitiesData([othersCommunity])
          // }
          // if (res.data?.clients) {
          //   clientData = clientData.map((client) => ({
          //     ...client,
          //     checked: filterClient.includes(client.id),
          //   }))
          //   setClientData([...clientData])
          // } else {
          //   setClientData([])
          // }
          // if (res.data?.staffMembers) {
          //   const staffData = res.data.staffMembers.map((staff) => ({
          //     ...staff,
          //     checked: filterUser.includes(staff.id),
          //   }))
          //   setUserData([...staffData])
          // } else {
          //   setUserData([])
          // }

          /* Moved filters to new endpoint: /webservice/request/get-all-request-filters */
          updatePaymentFromQb(ids)
        })
        .catch((errors) => {
          console.log(errors, 'error in fetching all requests')
        })
    } catch (error) {
      console.log('fetchAllRequest error : ', error)
    } finally {
      setLoadingCardsAdd(false)
    }
  }

  const updatePaymentFromQb = async (ids) => {
    try {
      let user = JSON.parse(localStorage.getItem('user'))
      console.log('useruseruseruser', user)
      let admin_email = user.email
      let company_name = user.company_name
      let username = user.person_name
      let user_role = user.user_role
      const response = await axios.post(
        `${REST_API_END_POINT}sales-order/update-payment-from-qb`,
        { userId, allId: ids, admin_email, company_name, username, user_role },
      )
      if (response.data.details.success > 0) {
        // fetchAllRequest()
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    if (!userId) return
    fetchSalesOrderTabGlowFlags()
    // Glow is dismissed only when the user switches tabs (handleChangeTab), not on page load.
    // Clearing on mount caused intermittent missing glow after switching back to admin when
    // the default tab matched the tab that should glow (e.g. staff create → AWAITING APPROVAL).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, locationState.pathname])

  useEffect(() => {
    if (!userId) return
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        fetchSalesOrderTabGlowFlags()
      }
    }
    document.addEventListener('visibilitychange', onVisible)
    return () => document.removeEventListener('visibilitychange', onVisible)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  useEffect(() => {
    if (!filtersInitialized) return
    if (isDeletingFilters) return
    if (!skipFetch) {
      fetchAllRequest()
      // fetchAllRequestNew()
    }
    setSkipFetch(false)
  }, [
    open,
    page,
    searching,
    rowsPerPage,
    sort,
    filterDateValue,
    filterCommunity,
    filterClient,
    filterUser,
    dueData,
    filterProjectType,
    renderCard,
    filterProjectCategory,
    filtersInitialized,
    isDeletingFilters,
    currentTab,
  ])

  // Call once on mount: load filters only initially (Add-data will load from Settings click)
  useEffect(() => {
    fetchRequestFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Load saved filters for Official Request page from shared preferences API
  useEffect(() => {
    const loadSavedRequestFilters = async () => {
      try {
        if (!userId) return;

        const response = await axios.post(`${REST_API_END_POINT}get-project-filters`, {
          userId,
          pageKey: splitOrder ? 'request-split' : 'request',
        });

        if (response?.data?.status === 1 && response?.data?.data) {
          const saved = response.data.data;
          if (saved.filtersApplied) {
            setFiltersApplied(true);
          }

          // Date range (timestamps in seconds)
          setFilterDateValue([
            saved.fromDate ? new Date(saved.fromDate * 1000) : null,
            saved.toDate ? new Date(saved.toDate * 1000) : null,
          ]);

          // Project type
          if (saved.projectTypeFilter !== undefined && saved.projectTypeFilter !== null) {
            const rawType = saved.projectTypeFilter;
            if (rawType === 'ALL' || rawType === 'all') {
              setFilterProjectType('ALL');
            } else {
              const numericType = Number(rawType);
              setFilterProjectType(!Number.isNaN(numericType) ? numericType : 'ALL');
            }
          }

          // By Due & sort
          setDueData(Number(saved.dueFilter) === 1);
          if (saved.sortFilter) {
            const matchedSort = SORT.find((item) => item.id === saved.sortFilter);
            if (matchedSort) {
              setSort(matchedSort);
            }
          }

          // Client / user / community filters
          if (Array.isArray(saved.clientFilter)) {
            setFilterClient(saved.clientFilter);
          }
          if (Array.isArray(saved.userFilter)) {
            setFilterUser(saved.userFilter);
          }
          if (Array.isArray(saved.communityFilter)) {
            setFilterCommunity(saved.communityFilter);
          }
        }
      } catch (error) {
        console.error('Error loading saved request filters:', error);
      } finally {
        setFiltersInitialized(true);
      }
    };

    loadSavedRequestFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deleteRequestFilters = async () => {
    if (!userId || isDeletingFilters) return;

    setIsDeletingFilters(true);
    try {
      await axios.post(`${REST_API_END_POINT}delete-project-filters`, {
        userId,
        pageKey: splitOrder ? 'request-split' : 'request',
      });

      setFilterClient([]);
      setFilterUser([]);
      setFilterCommunity([]);
      setFilterProjectType('ALL');
      setDueData(true);
      setSort(SORT[0]);
      setFilterDateValue([null, null]);
      setPage(0);
      setFiltersApplied(false);
    } catch (error) {
      console.error('Error deleting request filters:', error);
    } finally {
      setIsDeletingFilters(false);
    }
  };

  // Scroll to the real top of the dashboard main column on pagination (immediate + next frames).
  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const anchor = paginationScrollAnchorRef.current
    const run = () => scrollDashboardAncestorsToTop(anchor)
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  // After the page fetch finishes, layout height can change — scroll again so we stay at the true top.
  useEffect(() => {
    const prev = prevLoadingCardsForPaginationScrollRef.current
    prevLoadingCardsForPaginationScrollRef.current = loadingCards
    if (prev !== true || loadingCards !== false) return
    const anchor = paginationScrollAnchorRef.current
    const run = () => scrollDashboardAncestorsToTop(anchor)
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [loadingCards])

  // Separate counts fetch (single API call based on selected tab)
  useEffect(() => {
    if (!filtersInitialized) return;
    if (isDeletingFilters) return;
    const buildWhereForTab = (tab) => {
      let whereCondition = ''
      const splitOrderCondition = splitOrder ? "r.is_split_order = 1" : "r.is_split_order = 0";
      if (tab == 'NEW') {
        whereCondition = ` r.new_order = 1 AND r.quotation = 0 AND r.hold=0 AND ${splitOrderCondition} `
      } else if (tab == 'AWAITING APPROVAL') {
        whereCondition = ` ((r.status=2) OR (r.status=3 AND r.min_payment_status=0) OR (r.split_mirror_status = 7 AND r.status = 3))AND r.hold=0 AND r.new_order = 0 AND ${splitOrderCondition} `
      } else if (tab == 'HOLD') {
        whereCondition = ` r.hold =1 AND r.status != 6 AND ${splitOrderCondition} `
      } else if (tab == 'ACCEPTED') {
        whereCondition = ` (r.status=3 AND r.min_payment_status =1 AND r.hold=0 AND r.new_order = 0 AND r.split_mirror_status = 0 AND (r.manager_approval_required=0 OR r.send_to_client=1)) AND ${splitOrderCondition} `
      } else if (tab == 'REJECTED') {
        whereCondition = ` r.status = 6 AND ${splitOrderCondition} `
      } else if (tab == 'NO SERVICE NO TASK') {
        whereCondition = ` r.noServiceNoTask = 1 AND r.status=4 and i.status IS NULL and proj.status = 3 AND r.hold=0 AND ${splitOrderCondition}  `
      } else if (tab == 'IN PRODUCTION') {
        whereCondition = ` ((r.status=4 and proj.status <> 3 AND r.hold=0 AND r.hold=0 AND r.new_order = 0) OR (r.for_parent_facility = 2 AND r.status = 4 AND r.received_status = 0) ) AND (r.split_mirror_status = 0 OR r.split_mirror_status = 6 OR r.split_mirror_status = 8) AND ${splitOrderCondition} `
      }       else if (tab == 'INSTALLATION') {
        whereCondition = `
        (
          (
            r.for_parent_facility = 2 
            AND r.status = 4
            AND r.split_mirror_status = 1
          )
            OR 
          (
          EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 1 AND inst_tab.status != 0) AND r.status != 3 AND proj.status = 3 AND
          (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
                AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
                )
                OR
                (
                  r.status = 4
                  AND r.received_status = 1
                  AND r.split_mirror_status = 1
                )
                OR
                (
                  (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
                  AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
                  AND COALESCE(i.pending_review, 0) = 1
                  AND r.installation_acceptance IS NULL
                )
                OR
                (
                  (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
                  AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
                  AND COALESCE(i.pending_review, 0) = 2
                  AND r.installation_acceptance IS NULL
                )
        )
              AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'RETURNED') {
        whereCondition = `
        i.status IS NOT NULL AND i.status = 5 AND i.complete_status IN (1,2,3) AND i.status != 0 AND r.status != 3 AND
        (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
              AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'PICKUP') {
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 2
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 2) AND r.status != 3 AND proj.status = 3 AND 
          (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
        )
            OR
            (
              r.status = 4
              AND r.received_status = 1
              AND r.split_mirror_status = 2
            )
          )
            AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'SHIPPING') {
        whereCondition = `
        ((
          r.for_parent_facility = 2 
          AND r.status = 4
          AND r.split_mirror_status = 3
        )
          OR 
        (
        EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = 3) AND r.status != 3 AND proj.status = 3 AND 
          (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
            )
            OR
            (
              r.status = 4
              AND r.received_status = 1
              AND r.split_mirror_status = 3
            )
        )
            AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'COMPLETED') {
        whereCondition = `
        ((r.for_parent_facility = 2 AND r.status = 4 AND r.split_mirror_status = 5) OR
        ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
        (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
        AND r.installation_acceptance IS NOT NULL
        AND NOT (r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)))
        AND COALESCE(r.is_grouped_request, 0) != 2
        AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'REVIEW') {
        whereCondition = `
      ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
      (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
        AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
    AND r.installation_acceptance IS NULL AND r.isReview =2
    AND r.hold=0 AND ${splitOrderCondition} 
  `
      } else if (tab == 'INVOICING') {
        whereCondition = buildInvoicingTabWhereCondition(splitOrderCondition)
      } else if (tab == 'ARCHIVE') {
        whereCondition = `
        r.installation_acceptance IS NOT NULL AND r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)
        AND r.hold=0 AND ${splitOrderCondition} 
      `
      } else if (tab == 'VOID') {
        whereCondition = ` r.status = 10 AND r.quotation = 0 AND ${splitOrderCondition} `
      } else if (tab == 'ALL') {
        return buildAllTabWhereCondition(splitOrderCondition, {
          isClientUser: isClient || userType === 3,
          includeStatusFilter: true,
        })
      }
      return whereCondition
    }

    const where = buildWhereForTab(currentTab)
    const payload = {
      userType: viewasadmin ? 1 : userType,
      userId,
      page: 1,
      rowsPerPage: 1,
      search: searching,
      where,
      sort: sort?.id,
      from: filterDateValue && filterDateValue[0]
        ? moment(filterDateValue[0]).format('YYYY-MM-DD HH:mm:ss')
        : null,
      to: filterDateValue && filterDateValue[1]
        ? moment(filterDateValue[1]).format('YYYY-MM-DD HH:mm:ss')
        : null,
      dueData,
      filterCommunity,
      filterClient,
      filterProjectType: filterProjectType === 'ALL' ? undefined : filterProjectType,
      filterUser,
      filterProjectCategory: filterProjectCategory === 'ALL' ? undefined : filterProjectCategory,
    }

    axios.post(`${REST_API}webservice/request/get-all-request-total-count`, payload)
      .then((res) => {
        const count = Number(res?.data?.data?.totalCount)
        if (!Number.isFinite(count) || count < 0) return
        // set the selected tab's badge count
        if (currentTab === 'ALL') setAllCount(count)
        else if (currentTab === 'HOLD') setHoldCount(count)
        else if (currentTab === 'NEW') setOpenCount(count)
        else if (currentTab === 'AWAITING APPROVAL') setOpenCount(count)
        else if (currentTab === 'ACCEPTED') setAcceptedCount(count)
        else if (currentTab === 'REJECTED') setRejectedCount(count)
        else if (currentTab === 'IN PRODUCTION') setinProductionCount(count)
        else if (currentTab === 'INSTALLATION') setInstallsCount(count)
        else if (currentTab === 'PICKUP') setPickupCount(count)
        else if (currentTab === 'SHIPPING') setShippingCount(count)
        else if (currentTab === 'RETURNED') setReturnedCount(count)
        else if (currentTab === 'REVIEW' || currentTab === 'INVOICING') setInvoiceCount(count)
        else if (currentTab === 'COMPLETED') setCompletedCount(count)
        else if (currentTab === 'ARCHIVE') setCompletedCount(count)
        else if (currentTab === 'VOID') setVoidCount(count)

        // reflect selected tab count in pagination
        setTotalCount(count)
      })
      .catch((err) => console.log('count fetch error', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, userType, searching, sort, filterDateValue, dueData, filterCommunity, filterClient, filterProjectType, filterUser, currentTab, filterProjectCategory, renderCard, filtersInitialized, isDeletingFilters])

  const handleOnDragEnd = (result) => {
    // Check if item was dropped outside of the list
    if (!result.destination) return

    // Create a copy of the original array
    const reorderedItems = Array.from(allRequest)

    // Remove the item from its original position
    const [movedItem] = reorderedItems.splice(result.source.index, 1)

    // Insert the item at the new position
    reorderedItems.splice(result.destination.index, 0, movedItem)

    // Update the state with the reordered items
    setAllRequest(reorderedItems)

    // Persist the new order (ensure this function handles errors appropriately)
    saveNewOrder(reorderedItems)
  }

  const saveNewOrder = async (reorderedItems) => {
    try {
      await axios.post(`${REST_API}webservice/request/save-order`, {
        reorderedItems,
      })
      console.log('Order saved successfully')
    } catch (error) {
      console.error('Error saving order:', error)
    }
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  function handleToggleCommunity(id) {
    setFilterCommunity((prevIds) => {
      // If not yet in filterCommunity, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it’s already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }
  function handleToggleClient(id) {
    setFilterClient((prevIds) => {
      // If not yet in filterCommunity, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }
  function handleToggleUser(id) {
    setFilterUser((prevIds) => {
      // If not yet in filterUser, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

  const calculateTotal = (
    price,
    quantity,
    discount = 0,
    location = 1,
    adjustment = 0,
    markAdjType = 1,
  ) => {
    const parsedQuantity = parseFloat(quantity) || 1
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const newPrice = parseFloat(price) || 0
    // let subtotal = price * parsedQuantity * locationQuantity;

    let SPMA =
      newPrice + (newPrice * (adjustment ? Number(adjustment) : 0)) / 100
    let subtotal =
      parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity

    if (markAdjType == 2 || markAdjType == 3) {
      SPMA = newPrice + (adjustment ? Number(adjustment) : 0)
      subtotal =
        parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity
    }

    if (discount) {
      subtotal = subtotal - discount
    }
    // if (adjustment) {
    //   subtotal = subtotal + ((subtotal * adjustment) / 100);
    // }
    return subtotal
  }

  const calculateServiceTotal = (price, quantity, discount, location = 1) => {
    const parsedQuantity = parseFloat(quantity) || 0
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity
    if (discount) {
      const totalDiscount = subtotal - discount
      return totalDiscount
    } else {
      return subtotal
    }
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy)
  }

  function applySortFilter(array, comparator, community) {
    if (!Array.isArray(array)) {
      return []
    }
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    // Filter based on the community parameter
    if (community && community?.length > 0) {
      if (community?.includes('other')) {
        array = array?.filter(
          (item) =>
            item?.community === null || community?.includes(item?.community),
        )
      } else {
        array = array?.filter((item) => community?.includes(item?.community))
      }
    }
    return array
  }

  const handleChangeTab = async (event, newValue) => {
    try {
      setLoadingCards(true)
      setSkipFetch(true)
      const previousTab = currentTab
      if (previousTab !== newValue && previousTab) {
        await clearSalesOrderTabGlowOnTabOpen(previousTab)
      }
      setCurrentTab(newValue)
      await clearSalesOrderTabGlowOnTabOpen(newValue)
      setSelectedInvoiceGroupIds([])
      handleCloseGroupedInvoiceDialog()
      // const clearedSearch = '';
      // setSearching(clearedSearch);
      setFilterDateValue([null, null])
      setSalesOrderName('')
      setSalesOrderId('')
      let newPage = 0
      setPage(0)
      const splitOrderCondition = splitOrder ? "r.is_split_order = 1" : "r.is_split_order = 0";
      if (newValue == 'NEW') {
        let user = JSON.parse(localStorage.getItem('user'))
        

        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` r.new_order = 1  AND r.quotation = 0 AND r.hold=0 AND ${splitOrderCondition} `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType:filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)

            setAllRequest(res.data?.data?.data || [])
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (newValue == 'AWAITING APPROVAL') {
        let user = JSON.parse(localStorage.getItem('user'))


        const values = {
          // userType: userType, userId: userId, page: newPage + 1, rowsPerPage, search: searching, where: ` r.status=2`,
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` ((r.status=2) OR (r.status=3 AND r.min_payment_status=0) OR (r.split_mirror_status = 7 AND r.status = 3)) AND r.hold=0 AND r.new_order = 0 AND ${splitOrderCondition} `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)

            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (newValue == 'HOLD') {
        let user = JSON.parse(localStorage.getItem('user'))
        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` r.hold=1 AND r.status != 6 AND ${splitOrderCondition} `, //r.status=4 OR
          // where: ` r.status=3`, //r.status=4 OR
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setAllCount(res?.data?.data?.allCount || 0)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
      else if (newValue == 'ACCEPTED') {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` (r.status=3 AND r.min_payment_status =1 AND r.hold=0 AND r.new_order = 0 AND r.split_mirror_status = 0) AND ${splitOrderCondition} `, //r.status=4 OR
          // where: ` r.status=3`, //r.status=4 OR
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
      else if (newValue == 'REJECTED') {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` r.status = 6 AND ${splitOrderCondition} `, //r.status=4 OR
          // where: ` r.status=3`, //r.status=4 OR
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }


      else if (newValue == 'NO SERVICE NO TASK') {
        let user = JSON.parse(localStorage.getItem('user'))

        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` r.noServiceNoTask = 1 AND r.status=4 and i.status IS NULL and proj.status = 3 AND r.hold=0 AND ${splitOrderCondition} `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (newValue == 'IN PRODUCTION') {
        let user = JSON.parse(localStorage.getItem('user'))

        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` ((r.status=4 and proj.status <> 3 AND r.hold=0 AND r.hold=0 AND r.new_order = 0) OR (r.for_parent_facility = 2 AND r.status = 4 AND r.received_status = 0) ) AND (r.split_mirror_status = 0 OR r.split_mirror_status = 6 OR r.split_mirror_status = 8) AND ${splitOrderCondition} `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (
        newValue == 'INSTALLATION' ||
        newValue == 'PICKUP' ||
        newValue == 'SHIPPING'
      ) {
        let user = JSON.parse(localStorage.getItem('user'))


        let completeStatus =
          newValue == 'INSTALLATION' ? 1 : newValue == 'PICKUP' ? 2 : 3
        const installationReviewOr = newValue == 'INSTALLATION' ? `
          OR
          (
            (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
            AND COALESCE(i.pending_review, 0) = 1
            AND r.installation_acceptance IS NULL
          )
          OR
          (
            (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
            AND COALESCE(i.pending_review, 0) = 2
            AND r.installation_acceptance IS NULL
          )` : ''
        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          //old
          // where: ` i.status IS NOT NULL AND ( COALESCE(inst_counts.installation_count, 0) <
          // COALESCE(cop.product_count, 0) OR (pc.name = 'Service Only' AND
          //COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) ) `,
          where: `
          ((
            r.for_parent_facility = 2 
            AND r.status = 4
            AND r.split_mirror_status = ${completeStatus}
          )
            OR 
          (
          EXISTS (SELECT 1 FROM installations inst_tab WHERE inst_tab.request_id = r.id AND inst_tab.status IS NOT NULL AND inst_tab.status != 5 AND inst_tab.complete_status = ${completeStatus} AND inst_tab.status != 0) AND r.status != 3 AND proj.status = 3 AND
            (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
                AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
                )
          OR
          (
          r.status = 4
          AND r.received_status = 1
          AND r.split_mirror_status = ${completeStatus}
          )
          ${installationReviewOr}
          )
                AND r.hold=0 AND ${splitOrderCondition} 
        `,
          //   where : `
          //    i.status IS NOT NULL AND i.status != 5 AND i.complete_status = ${completeStatus} AND 
          //   (
          //     (r.project_category = 12 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
          //     (r.project_category = 11 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(rss.service_count, 0)) OR
          //     (r.project_category = 14 AND COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
          //     (COALESCE(inst_counts.installation_count, 0) < COALESCE(cop.product_count, 0))
          //   )
          // `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (
        newValue == 'RETURNED'
      ) {
        let user = JSON.parse(localStorage.getItem('user'))


        let completeStatus =
          newValue == 'RETURNED' ? 1 : 1
        const values = {
          userType: userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: `
           i.status IS NOT NULL AND i.status = 5 AND i.complete_status IN (1,2,3) AND i.status != 0 AND r.status != 3 AND
            (COALESCE(inst_counts.installation_count, 0) < COALESCE(total_inst_counts.total_installation_count, 0))
              AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)
              AND r.hold=0 AND ${splitOrderCondition} 
        `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }

            // setAllCount(res?.data?.data?.allCount || 0)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
      else if (newValue == 'COMPLETED') {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          // where: `i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) AND r.installation_acceptance IS NOT NULL `,
          where: `
          ((r.for_parent_facility = 2 AND r.status = 4 AND r.split_mirror_status = 5) OR
          ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
          (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
            AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
          AND r.installation_acceptance IS NOT NULL
          AND NOT (r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60)))
          AND COALESCE(r.is_grouped_request, 0) != 2
          AND r.hold=0 AND ${splitOrderCondition} 
        `,
          //   where: `
          //   i.status IS NOT NULL AND 
          //   (
          //     (r.project_category = 12 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
          //     (r.project_category = 11 AND inst_counts.installation_count >= COALESCE(rss.service_count, 0)) OR
          //     (r.project_category = 14 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
          //     (r.project_category NOT IN (11, 12, 14) AND inst_counts.installation_count >= COALESCE(cop.product_count, 0))
          //   ) 
          //   AND r.installation_acceptance IS NOT NULL
          // `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
      else if (newValue == 'REVIEW') {
        let user = JSON.parse(localStorage.getItem('user'))

        const values = {
          userType: userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          // where: ` i.status IS NOT NULL AND ( inst_counts.installation_count >= cop.product_count OR inst_counts.installation_count >= rss.service_count ) AND r.installation_acceptance IS NULL `,
          where: `
              ((proj.status = 3 AND total_inst_counts.total_installation_count IS NULL AND 
            r.noServiceNoTask = 0 AND r.status=4) OR (i.status IS NOT NULL AND 
                  (COALESCE(inst_counts.installation_count, 0) >= COALESCE(total_inst_counts.total_installation_count, 0))
                    AND (COALESCE(total_inst_counts.total_installation_count, 0) > 0)))
                AND r.installation_acceptance IS NULL AND r.isReview =2
                AND r.hold=0 AND ${splitOrderCondition} 
              `,
             
              from: filterDateValue[0],
              to: filterDateValue[1],
              filterCommunity: filterCommunity,
              filterClient: filterClient,
              filterUser: filterUser,
              dueData: dueData,
              filterProjectType:filterProjectType,
              filterProjectCategory: filterProjectCategory,
              currentTab: newValue,
            }
            await axios
              .post(`${REST_API}webservice/request/get-all-request-new`, values)
              .then((res) => {
                res.data.data
                const ids = res?.data?.data.data.map((item) => item.id)
                setAllId(ids)
                setAllRequest(res.data?.data?.data || [])
                // if (res?.data?.data?.totalCount) {
                //   setTotalCount(res?.data?.data?.totalCount)
                // } else {
                //   setTotalCount(0)
                // }
                // setOpenCount(res?.data?.data?.openCount || 0)
                // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
                // setAllCount(res?.data?.data?.allCount || 0)
                // setinProductionCount(res?.data?.data?.inProductionCount || 0)
                // setCompletedCount(res?.data?.data?.completedCount || 0)
                // setInstallsCount(res?.data?.data?.installsCount || 0)
                // setShippingCount(res?.data?.data?.shippingCount || 0)
                // setPickupCount(res?.data?.data?.pickupCount || 0)
                // setLoadingCards(false);
                // setRequestTeam(res.data.requestTeam)
                // setSkillServices(res.data.services)
                // setWorkFlow(res.data.workflows)
                // setAllproducts(res.data.products)
                // setLabourCostServices(res.data.labourCostServices)
                // setFilteredServices(res.data.labourCostServices)
                // const othersCommunity = { id: 'other', name: 'Others' }
                // let communitiesData = res.data.community || []
                // if (res.data?.community) {
                //   // setCommunitiesData([...res.data.community, othersCommunity]);
                //   communitiesData = communitiesData.map((community) => ({
                //     ...community,
                //     checked: filterCommunity.includes(community.id),
                //   }))
    
                //   setCommunitiesData([...communitiesData]) //othersCommunity
                // } else {
                //   setCommunitiesData([othersCommunity])
                // }
                // updatePaymentFromQb(ids)
              })
              .catch((errors) => {
                console.log(errors, 'error in fetching all requests')
              })
      }
      else if (newValue == 'INVOICING') {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: buildInvoicingTabWhereCondition(splitOrderCondition),
              //   where :`
              //   i.status IS NOT NULL AND 
              //   (
              //     (r.project_category = 12 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
              //     (r.project_category = 11 AND inst_counts.installation_count >= COALESCE(rss.service_count, 0)) OR
              //     (r.project_category = 14 AND inst_counts.installation_count >= COALESCE(cop.product_count, 0) + COALESCE(rss.service_count, 0)) OR
              //     (inst_counts.installation_count >= COALESCE(cop.product_count, 0))
              //   ) 
              //   AND r.installation_acceptance IS NULL
              // `,
              from: filterDateValue[0],
              to: filterDateValue[1],
              filterCommunity: filterCommunity,
              filterClient: filterClient,
              filterUser: filterUser,
              dueData: dueData,
              filterProjectType:filterProjectType,
              filterProjectCategory: filterProjectCategory,
              currentTab: newValue,
            }
            await axios
              .post(`${REST_API}webservice/request/get-all-request-new`, values)
              .then((res) => {
                res.data.data
                const ids = res?.data?.data.data.map((item) => item.id)
                setAllId(ids)
                setAllRequest(res.data?.data?.data || [])
                applyTabTotalCount(res, newValue)
                //   setTotalCount(res?.data?.data?.totalCount)
                // } else {
                //   setTotalCount(0)
                // }
                // setOpenCount(res?.data?.data?.openCount || 0)
                // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
                // setAllCount(res?.data?.data?.allCount || 0)
                // setinProductionCount(res?.data?.data?.inProductionCount || 0)
                // setCompletedCount(res?.data?.data?.completedCount || 0)
                // setInstallsCount(res?.data?.data?.installsCount || 0)
                // setShippingCount(res?.data?.data?.shippingCount || 0)
                // setPickupCount(res?.data?.data?.pickupCount || 0)
                // setLoadingCards(false);
                // setRequestTeam(res.data.requestTeam)
                // setSkillServices(res.data.services)
                // setWorkFlow(res.data.workflows)
                // setAllproducts(res.data.products)
                // setLabourCostServices(res.data.labourCostServices)
                // setFilteredServices(res.data.labourCostServices)
                // const othersCommunity = { id: 'other', name: 'Others' }
                // let communitiesData = res.data.community || []
                // if (res.data?.community) {
                //   // setCommunitiesData([...res.data.community, othersCommunity]);
                //   communitiesData = communitiesData.map((community) => ({
                //     ...community,
                //     checked: filterCommunity.includes(community.id),
                //   }))
    
                //   setCommunitiesData([...communitiesData]) //othersCommunity
                // } else {
                //   setCommunitiesData([othersCommunity])
                // }
                // updatePaymentFromQb(ids)
              })
              .catch((errors) => {
                console.log(errors, 'error in fetching all requests')
              })
      }else if (newValue == 'ARCHIVE') {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where :` r.installation_acceptance IS NOT NULL AND r.installation_acceptance = 1 AND r.timestamp <= UNIX_TIMESTAMP() - (30 * 24 * 60 * 60) AND r.hold=0 AND ${splitOrderCondition} `,
          
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      } else if (newValue == 'VOID') {
        let user = JSON.parse(localStorage.getItem('user'))

        const values = {
          userType: userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: ` r.status = 10 AND r.quotation = 0 AND ${splitOrderCondition} `,
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
      else {
        let user = JSON.parse(localStorage.getItem('user'))



        const values = {
          userType: viewasadmin ? 1 : userType,
          userId: userId,
          page: newPage + 1,
          rowsPerPage,
          search: searching,
          where: buildAllTabWhereCondition(splitOrderCondition, {
            isClientUser: isClient || userType === 3,
          }),
          from: filterDateValue[0],
          to: filterDateValue[1],
          filterCommunity: filterCommunity,
          filterClient: filterClient,
          filterUser: filterUser,
          dueData: dueData,
          filterProjectType: filterProjectType,
          filterProjectCategory: filterProjectCategory,
          currentTab: newValue,
        }
        await axios
          .post(`${REST_API}webservice/request/get-all-request-new`, values)
          .then((res) => {
            res.data.data
            const ids = res?.data?.data.data.map((item) => item.id)
            setAllId(ids)
            setAllRequest(res.data?.data?.data || [])
            // if (res?.data?.data?.totalCount) {
            //   setTotalCount(res?.data?.data?.totalCount)
            // } else {
            //   setTotalCount(0)
            // }
            // setOpenCount(res?.data?.data?.openCount || 0)
            // setAcceptedCount(res?.data?.data?.acceptedCount || 0)
            // setAllCount(res?.data?.data?.allCount || 0)
            // setinProductionCount(res?.data?.data?.inProductionCount || 0)
            // setCompletedCount(res?.data?.data?.completedCount || 0)
            // setInstallsCount(res?.data?.data?.installsCount || 0)
            // setShippingCount(res?.data?.data?.shippingCount || 0)
            // setPickupCount(res?.data?.data?.pickupCount || 0)
            // setLoadingCards(false);
            // setRequestTeam(res.data.requestTeam)
            // setSkillServices(res.data.services)
            // setWorkFlow(res.data.workflows)
            // setAllproducts(res.data.products)
            // setLabourCostServices(res.data.labourCostServices)
            // setFilteredServices(res.data.labourCostServices)
            // const othersCommunity = { id: 'other', name: 'Others' }
            // let communitiesData = res.data.community || []
            // if (res.data?.community) {
            //   // setCommunitiesData([...res.data.community, othersCommunity]);
            //   communitiesData = communitiesData.map((community) => ({
            //     ...community,
            //     checked: filterCommunity.includes(community.id),
            //   }))

            //   setCommunitiesData([...communitiesData]) //othersCommunity
            // } else {
            //   setCommunitiesData([othersCommunity])
            // }
            // updatePaymentFromQb(ids)
          })
          .catch((errors) => {
            console.log(errors, 'error in fetching all requests')
          })
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCards(false)
    }
  }
  const filteredUsers = applySortFilter(
    allRequest,
    getComparator(order, orderBy),
    [],
  )
  const selectedInvoiceGroupRows = filteredUsers.filter((row) => selectedInvoiceGroupIds.includes(row.id))
  const isInvoiceGroupingTab = currentTab === 'INVOICING'
  const isInvoiceGroupingEnabled = isInvoiceGroupingTab && valueTab === 'one'
  const isInvoiceListGroupingEnabled = isInvoiceGroupingTab && valueTab !== 'one'
  const NO_CHARGE_PROJECT_CATEGORY = 13
  const getInvoiceGroupingKey = (row) => (
    `${row?.customer_id || 'client-null'}:${row?.community || 'project-null'}:${row?.job_type || 'jobtype-null'}`
  )
  const isNoChargeInvoiceOrder = (row) => Number(row?.project_category) === NO_CHARGE_PROJECT_CATEGORY
  const canGroupInvoiceOrders = (firstRow, row) => {
    if (!firstRow || getInvoiceGroupingKey(firstRow) !== getInvoiceGroupingKey(row)) return false
    const firstIsNoCharge = isNoChargeInvoiceOrder(firstRow)
    const rowIsNoCharge = isNoChargeInvoiceOrder(row)
    if (firstIsNoCharge || rowIsNoCharge) return firstIsNoCharge && rowIsNoCharge
    return true
  }
  const getGroupedSalesOrderNamesText = (card) => (
    (card?.grouped_requests || [])
      .map((row) => row?.name)
      .filter(Boolean)
      .join(', ') || 'Unknown Orders'
  )
  const getGroupedInvoiceDisplayName = (card) => {
  // This change ensures that the updated grouped invoice name is displayed on the card, preventing a mismatch between the card and the view page.
    if (card?.name && !String(card.name).startsWith('Combined Sales Orders')) {
      return card.name;
    }
    const count = card?.grouped_quantity
      || String(card?.grouped_request_ids || '').split(',').filter(Boolean).length
      || card?.grouped_requests?.length
      || 0
    return `Combined Sales Orders (${count}) - ${getGroupedSalesOrderNamesText(card)}`
  }
  const canSelectInvoiceGroupRow = (row) => {
    const groupedStatus = Number(row?.is_grouped_request || 0)
    return groupedStatus === 0 || groupedStatus === 1
  }
  const getSelectedGroupedParentId = (selectedIds) => {
    const parentId = selectedIds.find((id) => {
      const item = filteredUsers.find((row) => row.id === id)
      return item && Number(item.is_grouped_request || 0) === 1
    })
    return parentId || null
  }
  const canShowInvoiceGroupCheckbox = (row) => {
    if (!(isInvoiceGroupingEnabled || isInvoiceListGroupingEnabled) || !canSelectInvoiceGroupRow(row)) return false
    if (selectedInvoiceGroupIds.length === 0 || selectedInvoiceGroupIds.includes(row.id)) return true

    const firstSelectedRow = filteredUsers.find((item) => item.id === selectedInvoiceGroupIds[0])
    if (!firstSelectedRow || !canGroupInvoiceOrders(firstSelectedRow, row)) return false

    const selectedParentId = getSelectedGroupedParentId(selectedInvoiceGroupIds)
    if (Number(row.is_grouped_request || 0) === 1 && selectedParentId && row.id !== selectedParentId) {
      return false
    }

    return true
  }

  const handleToggleInvoiceGroupSelection = (row) => {
    if (!canSelectInvoiceGroupRow(row)) {
      enqueueSnackbar('This sales order is already part of a group.', { variant: 'warning' })
      return
    }

    setSelectedInvoiceGroupIds((prev) => {
      if (prev.includes(row.id)) {
        return prev.filter((id) => id !== row.id)
      }

      const firstSelectedRow = filteredUsers.find((item) => item.id === prev[0])
      if (firstSelectedRow && getInvoiceGroupingKey(firstSelectedRow) !== getInvoiceGroupingKey(row)) {
        enqueueSnackbar('Select sales orders with the same client, project and job type.', { variant: 'warning' })
        return prev
      }
      if (firstSelectedRow && !canGroupInvoiceOrders(firstSelectedRow, row)) {
        enqueueSnackbar('No Charge sales orders can only be combined with other No Charge orders.', { variant: 'warning' })
        return prev
      }

      if (Number(row.is_grouped_request || 0) === 1) {
        const existingParentId = getSelectedGroupedParentId(prev)
        if (existingParentId && existingParentId !== row.id) {
          enqueueSnackbar('You can only add sales orders to one existing group at a time.', { variant: 'warning' })
          return prev
        }
      }

      return [...prev, row.id]
    })
  }

  const handleGroupInvoiceRequests = async () => {
    if (selectedInvoiceGroupIds.length < 2 || groupingInvoiceRequests) return

    setGroupingInvoiceRequests(true)
    try {
      const response = await axios.post(`${REST_API}webservice/request/group-invoice-requests`, {
        requestIds: selectedInvoiceGroupIds,
        userId,
      })

      if (response?.data?.status === 1) {
        enqueueSnackbar(
          response?.data?.message || 'Sales orders grouped successfully.',
          { variant: response?.data?.qbSyncFailed ? 'warning' : 'success' },
        )
        const parentId = response?.data?.data?.parentRequestId
        setSelectedInvoiceGroupIds([])
        await fetchAllRequest()
        if (parentId) {
          handleOpenDetailsSalesOrder(parentId, 'Combined Sales Orders', false)
        }
      } else {
        enqueueSnackbar(response?.data?.message || 'Failed to group sales orders.', { variant: 'error' })
      }
    } catch (error) {
      console.log('group invoice requests error', error)
      enqueueSnackbar('Failed to group sales orders.', { variant: 'error' })
    } finally {
      setGroupingInvoiceRequests(false)
    }
  }

  const handleOpenGroupedInvoiceDialog = (card) => {
    setSelectedGroupedUngroupIds([])
    setGroupedInvoiceDialog({ open: true, card })
  }

  const handleCloseGroupedInvoiceDialog = () => {
    setSelectedGroupedUngroupIds([])
    setGroupedInvoiceDialog({ open: false, card: null })
  }

  const handleToggleGroupedUngroupSelection = (row) => {
    setSelectedGroupedUngroupIds((prev) => (
      prev.includes(row.id) ? prev.filter((id) => id !== row.id) : [...prev, row.id]
    ))
  }

  const handleUngroupInvoiceRequests = async (parentRequestId, requestIds) => {
    const resolvedParentId =
      parentRequestId != null
      && (typeof parentRequestId === 'number' || typeof parentRequestId === 'string')
        ? parentRequestId
        : groupedInvoiceDialog.card?.id
    const resolvedRequestIds = Array.isArray(requestIds) ? requestIds : selectedGroupedUngroupIds
    const parentId = resolvedParentId
    const ids = resolvedRequestIds

    if (!parentId || !ids?.length || ungroupingInvoiceRequests) {
      return
    }

    setUngroupingInvoiceRequests(true)
    try {
      const response = await axios.post(`${REST_API}webservice/request/ungroup-invoice-requests`, {
        parentRequestId: parentId,
        requestIds: ids,
        userId,
      })

      if (response?.data?.status === 1) {
        enqueueSnackbar(response?.data?.message || 'Sales orders ungrouped successfully.', { variant: 'success' })
        const nextParentId = response?.data?.data?.parentRequestId || parentId

        if (groupedInvoiceDialog.open && groupedInvoiceDialog.card?.id === parentId) {
          const remainingCount = (groupedInvoiceDialog.card?.grouped_requests?.length || 0) - ids.length
          if (response?.data?.data?.dissolved || remainingCount <= 1) {
            handleCloseGroupedInvoiceDialog()
          } else {
            const remainingRequests = (groupedInvoiceDialog.card?.grouped_requests || []).filter(
              (row) => !ids.includes(row.id),
            )
            setGroupedInvoiceDialog((prev) => ({
              ...prev,
              card: {
                ...prev.card,
                id: nextParentId,
                grouped_requests: remainingRequests,
                grouped_quantity: remainingCount,
                grouped_request_ids: remainingRequests.map((row) => row.id).join(','),
              },
            }))
            setSelectedGroupedUngroupIds([])
          }
        }

        await fetchAllRequest()
      } else {
        enqueueSnackbar(response?.data?.message || 'Failed to ungroup sales orders.', { variant: 'error' })
      }
    } catch (error) {
      console.log('ungroup invoice requests error', error)
      enqueueSnackbar('Failed to ungroup sales orders.', { variant: 'error' })
    } finally {
      setUngroupingInvoiceRequests(false)
    }
  }
  // const filteredUsers = applySortFilter(allRequest, getComparator(order, orderBy), filterCommunity);

  const handleFilterProjectType = (type) => {
    setFilterProjectType(type);
  };

  const handleSplitProjectCategory = (category) => {
    setFilterProjectCategory(category);
  };
  const handleChangeSort = (category) => {
    setSort(category)
    setSortOpen(false)
  }

  const ACCOUNT_TABS = [
    {
      value: 'ALL',
      name: 'ALL',
      count: allCount || 0,
    },
    {
      value: 'NEW',
      name: 'NEW',
      count: openCount || 0,
    },
    {
      value: 'AWAITING APPROVAL',
      name: 'AWAITING APPROVAL',
      count: 0,
    },
    {
      value: 'ACCEPTED',
      name: 'APPROVED',
      count: acceptedCount || 0,
    },
    {
      value: 'IN PRODUCTION',
      name: 'IN PRODUCTION',
      count: inProductionCount || 0,
    },
    {
      value: 'INSTALLATION',
      name: 'INSTALLATION',
      count: installsCount || 0,
    },
    {
      value: 'PICKUP',
      name: 'PICK UP',
      count: pickupCount || 0,
    },
    {
      value: 'SHIPPING',
      name: 'SHIPPING',
      count: shippingCount || 0,
    },
    {
      value: 'RETURNED',
      name: 'RETURNED',
      count: installsCount || 0,
    },
    {
      value: 'REJECTED',
      name: 'REJECTED',
      count: rejectedCount || 0,
    },
    ...(isClient || userType === 3 ? [] : [{
      value: 'REVIEW',
      name: 'REVIEW',
      count: invoiceCount || 0,
    }]),
    {
      value: 'INVOICING',
      name: 'INVOICING',
      count: invoiceCount || 0,
    },
    {
      value: 'COMPLETED',
      name: 'COMPLETED',
      count: completedCount || 0,
    },
    {
      value: 'HOLD',
      name: 'HOLD',
      count: holdCount || 0,
    },
    {
      value: 'ARCHIVE',
      name: 'ARCHIVE',
      count: completedCount || 0,
    },
    {
      value: 'VOID',
      name: 'VOID',
      count: voidCount || 0,
    },
    // {
    //   value: 'NO SERVICE NO TASK',
    //   name: 'NO SERVICE NO TASK',
    //   count: completedCount || 0,
    // },
  ]

  const groupedDialogStatusCard = groupedInvoiceDialog.card?.grouped_requests?.[0]
    ? { ...groupedInvoiceDialog.card, ...groupedInvoiceDialog.card.grouped_requests[0] }
    : groupedInvoiceDialog.card
  const groupedDialogHasInstallationAcceptance =
    groupedDialogStatusCard?.installation_acceptance !== null
    && groupedDialogStatusCard?.installation_acceptance !== undefined
    && groupedDialogStatusCard?.installation_acceptance !== ''
  const hideGroupedUngroupControls =
    currentTab === 'COMPLETED'
    || currentTab === 'ARCHIVE'
    || (currentTab === 'ALL' && groupedDialogHasInstallationAcceptance)


  return (
    <Page title="Sales Order: list | Sign Wise Solutions">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HeaderBreadcrumbs
            heading={user.isVendor ? 'Proposals' : splitOrder ? 'Split Sales Order' : 'Sales Order'}
          // leftAction={
          //   (!user.isVendor && open) && (
          //     <MIconButton
          //       sx={{
          //         mr:1,
          //         // backgroundColor: '#8b8e92',
          //       //   '&:hover': {
          //       //     backgroundColor: '#454545', // Slightly lighter shade on hover
          //       //   },
          //       }}
          //       onClick={() => {
          //         setOpen(false);
          //         // formik.resetForm();
          //         setNewValues(null);
          //         setSelectedProducts([]);
          //         setSelectedServices([]);
          //         setAdditionalSelectedServices([])
          //         setFilteredServices([])
          //         setAllLocationSame(false)
          //         setAvatarUrl([])
          //         setAllMaterials([])
          //       }}
          //     >
          //       <Icon style={{color:'#ffffff'}} icon={arrowLeftFill} width={25} height={25} />
          //     </MIconButton>
          //   )
          // }
          />
          
          {(isAdminUser (userType) ||
            explodedPermissions?.some((permission) =>
              ['Create Request'].includes(permission),
            )) &&
            !user.isVendor &&
            open == false ? (
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              {
                splitOrder ?
              <ButtonGroup variant="outlined" sx={{ width: 'auto', gap: 0.5 }}>
                <Button
                  startIcon={<Stack className="si--projects-alt-duotone" />}
                  variant={filterProjectCategory === 'ALL' ? 'contained' : 'outlined'}
                  sx={{
                    boxShadow: 'none', 
                    width: 'auto', 
                    padding: '4px 10px',  // Reduced padding for smaller buttons
                    fontSize: '0.875rem',  // Reduced font size for smaller text
                  }}
                  onClick={() => handleSplitProjectCategory('ALL')}
                >
                  All
                </Button>
                <Button
                  startIcon={<Construction />}  // Icon for Build Order
                  variant={filterProjectCategory === 1 ? 'contained' : 'outlined'}
                  sx={{
                    boxShadow: 'none', 
                    width: 'auto', 
                    padding: '4px 10px',  // Reduced padding for smaller buttons
                    fontSize: '0.875rem',  // Reduced font size for smaller text
                  }}
                  onClick={() => handleSplitProjectCategory(1)}
                >
                  Build Order
                </Button>
                <Button
                  startIcon={<Storefront />}  // Icon for Retail
                  variant={filterProjectCategory === 2 ? 'contained' : 'outlined'}
                  sx={{
                    boxShadow: 'none', 
                    width: 'auto', 
                    padding: '4px 10px',  // Reduced padding for smaller buttons
                    fontSize: '0.875rem',  // Reduced font size for smaller text
                  }}
                  onClick={() => handleSplitProjectCategory(2)}
                >
                  Sales Order
                </Button>
              </ButtonGroup>
              :''
              }
              <Button
                ref={refSettings}
                onClick={handleOpenFilters}
                variant="contained"
                color="success"
                sx={{
                  border: filtersApplied ? '2px solid rgb(255, 0, 0)' : '1px solid #00c2ff',
                  color: 'common.white',
                }}
                startIcon={<FilterList />}
              >
                Filters
              </Button>
            { (userType === 1 || explodedPermissions?.some((permission) => ['Create Request'].includes(permission))) && (
              <Button
                disabled={loadingCardsAdd}
                onClick={async () => {
                  await fetchAllRequestNew()
                  setOpen(true)
                  setShowProgressModal(false)
                }}
                variant="contained"
                startIcon={
                  loadingCardsAdd ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Icon icon={plusFill} />
                  )
                }
              >
                {loadingCardsAdd ? 'Loading Data...' : `Add New ${splitOrder ? 'Split Sales Order' : 'Sales Order'}`}
              </Button>)}
            </Box>
          ) : (
            ''
          )}
        </Stack>
      <Popover
        open={isFiltersOpen}
        anchorEl={filtersAnchorEl}
        onClose={handleCloseFilters}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            width: { xs: '92vw', sm: 620, md: 780 },
            maxWidth: '92vw',
            p: 2,
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <MobileDateRangePicker
              startText="Filter Date"
              endText="Filter Date"
              value={filterDateValue}
              onChange={(newValue) => {
                setFilterDateValue(newValue)
              }}
              renderInput={(startProps, endProps) => (
                <>
                  <TextField
                    {...startProps}
                    sx={{ width: '100%' }}
                    helperText="Filter By Due Date"
                    label="From Date"
                    size="small"
                    InputLabelProps={{
                      style: {
                        color: theme.palette.primary.main,
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  />
                  <Box
                    sx={{
                      mx: 1,
                      color: theme.palette.primary.main,
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    -
                  </Box>
                  <TextField
                    {...endProps}
                    sx={{ width: '100%' }}
                    helperText=""
                    label="To Date"
                    size="small"
                    InputLabelProps={{
                      style: {
                        color: theme.palette.primary.main,
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  />
                </>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <ButtonGroup variant="outlined" sx={{ width: '100%' }}>
              <Button
                startIcon={<Stack className="si--projects-alt-duotone" />}
                variant={filterProjectType === 'ALL' ? 'contained' : 'outlined'}
                sx={{ boxShadow: 'none', width: '100%' }}
                onClick={() => handleFilterProjectType('ALL')}
              >
                All
              </Button>
              <Button
                startIcon={<Stack className="carbon--traffic-flow" />}
                variant={filterProjectType === 1 ? 'contained' : 'outlined'}
                sx={{ boxShadow: 'none', width: '100%' }}
                onClick={() => handleFilterProjectType(1)}
              >
                TS
              </Button>
              <Button
                startIcon={<Stack className="fluent--production-checkmark-20-regular" />}
                variant={filterProjectType === 2 ? 'contained' : 'outlined'}
                sx={{ boxShadow: 'none', width: '100%' }}
                onClick={() => handleFilterProjectType(2)}
              >
                PS
              </Button>
              {/* <Button
                startIcon={<Stack className="fluent--split-horizontal-20-regular" />}
                variant={filterProjectType === 3 ? 'contained' : 'outlined'}
                sx={{ boxShadow: 'none', width: '100%' }}
                onClick={() => handleFilterProjectType(3)}
              >
                Split
              </Button> */}
            </ButtonGroup>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Tabs
              value={valueTab}
              onChange={handleChangeGrid}
              textColor="secondary"
              indicatorColor="none"
              aria-label="secondary tabs example"
              sx={{ minHeight: 42 }}
            >
              <CustomTab value="one" icon={<ViewModule />} />
              <CustomTab value="two" icon={<ViewList />} />
              <CustomTab value="three" icon={<ListIcon />} />
            </Tabs>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack>
              {!user.isVendor && userType !== 3 && (
                <Button
                  ref={refClients}
                  onClick={() => setClientsOpen((prevState) => !prevState)}
                  variant="outlined"
                  type="submit"
                  sx={{ alignItems: 'flex-end' }}
                  endIcon={
                    <Stack>
                      {clientsOpen ? (
                        <ExpandLess sx={{ ml: 'auto' }} />
                      ) : (
                        <ExpandMore sx={{ ml: 'auto' }} />
                      )}
                    </Stack>
                  }
                >
                  Filter By Client
                </Button>
              )}
              <Menu
                open={Boolean(clientsOpen)}
                anchorEl={refClients.current}
                onClose={() => setClientsOpen(false)}
                PaperProps={{
                  sx: { width: 'auto', maxWidth: '100%' },
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Box sx={{ p: 2, pb: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search clients..."
                    value={clientSearchTerm}
                    onChange={(e) => setClientSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }} />
                </Box>
                <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredClients =
                      clientData?.filter((type) =>
                        type.name
                          ?.toLowerCase()
                          .includes(clientSearchTerm.toLowerCase()),
                      ) || []

                    // Sort in strict alphanumeric order
                    const sortedClients = filteredClients.sort((a, b) => {
                      const nameA = (a.name || '').trim();
                      const nameB = (b.name || '').trim();
                      return nameA.localeCompare(nameB, undefined, { 
                        numeric: true, 
                        sensitivity: 'base' 
                      });
                    });

                    if (sortedClients.length === 0 && clientSearchTerm) {
                      return (
                        <MenuItem disabled sx={{ justifyContent: 'center' }}>
                          <ListItemText
                            primary="No result found"
                            sx={{ textAlign: 'center' }}
                          />
                        </MenuItem>
                      )
                    }

                    return sortedClients.map((type) => (
                      <MenuItem key={type.id}>
                        {type.id === 'other' ? (
                          <ListItemText primary={`${type.name}`} />
                        ) : (
                          <ListItemText primary={`${type.name}`} />
                        )}
                        <Checkbox
                          checked={filterClient.includes(type.id)}
                          onChange={() => {
                            setPage(0)
                            handleToggleClient(type.id)
                          }}
                        />
                      </MenuItem>
                    ))
                  })()}
                </List>
              </Menu>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack>
              {!user.isVendor && (
                <Button
                  ref={refUsers}
                  onClick={() => setUsersOpen((prevState) => !prevState)}
                  variant="outlined"
                  type="submit"
                  sx={{ alignItems: 'flex-end' }}
                  endIcon={
                    <Stack>
                      {usersOpen ? (
                        <ExpandLess sx={{ ml: 'auto' }} />
                      ) : (
                        <ExpandMore sx={{ ml: 'auto' }} />
                      )}
                    </Stack>
                  }
                >
                  Filter By User
                </Button>
              )}
              <Menu
                open={Boolean(usersOpen)}
                anchorEl={refUsers.current}
                onClose={() => setUsersOpen(false)}
                PaperProps={{
                  sx: { width: 'auto', maxWidth: '100%' },
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Box sx={{ p: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search users..."
                    value={userSearchTerm}
                    onChange={(e) => setUserSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }} />
                </Box>
                <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredUsers = userData?.filter((user) => {
                      const searchText = userSearchTerm.toLowerCase()
                      const userName = (
                        user.userName ||
                        user.person_name ||
                        user.name ||
                        user.email ||
                        ''
                      ).toLowerCase()
                      return userName.includes(searchText)
                    }) || []

                    // Sort in strict alphanumeric order
                    const sortedUsers = filteredUsers.sort((a, b) => {
                      const nameA = (a.userName || a.person_name || a.name || a.email || '').trim();
                      const nameB = (b.userName || b.person_name || b.name || b.email || '').trim();
                      return nameA.localeCompare(nameB, undefined, { 
                        numeric: true, 
                        sensitivity: 'base' 
                      });
                    });

                    if (sortedUsers.length === 0 && userSearchTerm) {
                      return (
                        <MenuItem disabled sx={{ justifyContent: 'center' }}>
                          <ListItemText
                            primary="No result found"
                            sx={{ textAlign: 'center' }}
                          />
                        </MenuItem>
                      )
                    }

                    return sortedUsers.map((user) => (
                      <MenuItem key={user.id}>
                        <ListItemText
                          primary={`${user.userName || user.person_name || user.name || user.email}`}
                        />
                        <Checkbox
                          checked={filterUser.includes(user.id)}
                          onChange={() => {
                            setPage(0)
                            handleToggleUser(user.id)
                          }}
                        />
                      </MenuItem>
                    ))
                  })()}
                </List>
              </Menu>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
              <Button
                variant="outlined"
                sx={{
                  maxHeight: '36px',
                  backgroundColor: dueData ? '#1ccaff' : '',
                  color: dueData ? '#fff' : '',
                }}
                onClick={handleByDue}
                endIcon={
                  <Stack>
                    {dueData ? <Visibility /> : <VisibilityOff />}
                  </Stack>
                }
              >
                By Due
              </Button>
              <Stack>
                <Button
                  ref={refSort}
                  onClick={() => setSortOpen((prevState) => !prevState)}
                  variant="outlined"
                  disabled={dueData}
                  type="button"
                  endIcon={
                    <Stack>
                      {sortOpen ? (
                        <ExpandLess sx={{ ml: 'auto' }} />
                      ) : (
                        <ExpandMore sx={{ ml: 'auto' }} />
                      )}
                    </Stack>
                  }
                >
                  {sort.label}
                </Button>
                {dueData && (
                  <FormHelperText
                    sx={{ color: 'error.main', fontSize: '0.65rem', mt: 0.5 }}
                  >
                    Disable "By Due" to enable this.
                  </FormHelperText>
                )}
                <Menu
                  open={Boolean(sortOpen)}
                  anchorEl={refSort.current}
                  onClose={() => setSortOpen(false)}
                  PaperProps={{
                    sx: {
                      width: 'auto',
                      maxWidth: '100%',
                      maxHeight: '250px',
                    },
                  }}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  {SORT.map((category) => (
                    <MenuItem
                      key={category.id}
                      onClick={() => handleChangeSort(category)}
                    >
                      <ListItemText primary={category.label} />
                    </MenuItem>
                  ))}
                </Menu>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Stack>
              {!user.isVendor && (
                <Button
                  ref={refCommunities}
                  onClick={() =>
                    setCommunitiesOpen((prevState) => !prevState)
                  }
                  variant="outlined"
                  type="submit"
                  sx={{ alignItems: 'flex-end' }}
                  endIcon={
                    <Stack>
                      {communitiesOpen ? (
                        <ExpandLess sx={{ ml: 'auto' }} />
                      ) : (
                        <ExpandMore sx={{ ml: 'auto' }} />
                      )}
                    </Stack>
                  }
                >
                  Filter Project
                </Button>
              )}
              <Menu
                open={Boolean(communitiesOpen)}
                anchorEl={refCommunities.current}
                onClose={() => setCommunitiesOpen(false)}
                PaperProps={{
                  sx: { width: 'auto', maxWidth: '100%' },
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <Box sx={{ p: 2, pb: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Search projects..."
                    value={projectSearchTerm}
                    onChange={(e) => setProjectSearchTerm(e.target.value)}
                    fullWidth
                    variant="outlined"
                    sx={{
                      mb: 1,
                    }}
                  />
                  <Divider sx={{ mt: 1 }} />
                </Box>
                <List style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {(() => {
                    const filteredProjects =
                      communitiesData?.filter((type) =>
                        type.name
                          ?.toLowerCase()
                          .includes(projectSearchTerm.toLowerCase()),
                      ) || []

                    // Sort in strict alphanumeric order
                    const sortedProjects = filteredProjects.sort((a, b) => {
                      const nameA = (a.name || '').trim();
                      const nameB = (b.name || '').trim();
                      return nameA.localeCompare(nameB, undefined, { 
                        numeric: true, 
                        sensitivity: 'base' 
                      });
                    });

                    if (sortedProjects.length === 0 && projectSearchTerm) {
                      return (
                        <MenuItem disabled sx={{ justifyContent: 'center' }}>
                          <ListItemText
                            primary="No result found"
                            sx={{ textAlign: 'center' }}
                          />
                        </MenuItem>
                      )
                    }

                    return sortedProjects.map((type) => (
                      <MenuItem key={type.id}>
                        {type.id === 'other' ? (
                          <ListItemText primary={`${type.name}`} />
                        ) : (
                          <ListItemText
                            primary={`${type.name} (${type.no_of_requests})`}
                          />
                        )}
                        <Checkbox
                          checked={filterCommunity.includes(type.id)}
                          onChange={() => {
                            setPage(0)
                            handleToggleCommunity(type.id)
                          }}
                        />
                      </MenuItem>
                    ))
                  })()}
                </List>
              </Menu>
            </Stack>
          </Grid>
          {filtersApplied && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={deleteRequestFilters}
                    disabled={isDeletingFilters}
                    startIcon={<Delete />}
                    sx={{ mt: 2, ml: 2 }}
                  >
                    {isDeletingFilters ? 'Resetting...' : 'Reset Filters'}
                  </Button>
                )}

          <Grid item xs={12}>
            {filterCommunity?.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  border: 1,
                  borderColor: 'primary.main',
                  borderRadius: 1,
                  px: 1,
                  py: 0.5,
                  maxWidth: '100%',
                  height: 70,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  marginRight: 2,
                  marginBottom: 2,
                }}
              >
                <span
                  style={{
                    color: theme.palette.primary.darker,
                    marginRight: 8,
                    whiteSpace: 'nowrap',
                  }}
                >
                  Selected Projects{' '}
                </span>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {communitiesData
                    .filter((community) => filterCommunity?.includes(community.id))
                    .map((community) => (
                      <Chip
                        key={community.id}
                        label={community.name}
                        size="small"
                        onDelete={() => handleToggleCommunity(community.id)}
                      />
                    ))}
                </Box>
              </Box>
            )}
            {filterClient?.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  border: 1,
                  borderColor: 'primary.main',
                  borderRadius: 1,
                  px: 1,
                  py: 0.5,
                  maxWidth: '100%',
                  height: 70,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  marginRight: 2,
                  marginBottom: 2,
                }}
              >
                <span
                  style={{
                    color: theme.palette.primary.darker,
                    marginRight: 8,
                    whiteSpace: 'nowrap',
                  }}
                >
                  Selected Clients{' '}
                </span>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {clientData
                    .filter((client) => filterClient?.includes(client.id))
                    .map((client) => (
                      <Chip
                        key={client.id}
                        label={client.name}
                        size="small"
                        onDelete={() => handleToggleClient(client.id)}
                      />
                    ))}
                </Box>
              </Box>
            )}
            {filterUser?.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  border: 1,
                  borderColor: 'primary.main',
                  borderRadius: 1,
                  px: 1,
                  py: 0.5,
                  maxWidth: '100%',
                  height: 70,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  marginRight: 2,
                  marginBottom: 2,
                }}
              >
                <span
                  style={{
                    color: theme.palette.primary.darker,
                    marginRight: 8,
                    whiteSpace: 'nowrap',
                  }}
                >
                  Selected Users{' '}
                </span>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {userData
                    .filter((user) => filterUser?.includes(user.id))
                    .map(
                      (user) => (
                        <Chip
                          key={user.id}
                          label={user.userName ||
                            user.person_name ||
                            user.name ||
                            user.email}
                          size="small"
                          onDelete={() => handleToggleUser(user.id)}
                        />
                      ),
                    )}
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Popover>
      {!open && (
        <Box sx={{ mt: -4 }}>
          <OfficialRequestSearch
            searching={searching}
            setSearching={handleSearchingChange}
            setAllRequest={setAllRequest}
          />
        </Box>
      )}
        {open ? (
          <OfficialRequestAdd
            open={open}
            setShowProgressModal={setShowProgressModal}
            showProgressModal={showProgressModal}
            searching={searching}
            setOpen={setOpen}
            page={page}
            setPage={setPage}
            preview={preview}
            setPreview={setPreview}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalCount={totalCount}
            setTotalCount={setTotalCount}
            allCount={allCount}
            setAllCount={setAllCount}
            acceptedCount={acceptedCount}
            setAcceptedCount={setAcceptedCount}
            openCount={openCount}
            setOpenCount={setOpenCount}
            inProductionCount={inProductionCount}
            setinProductionCount={setinProductionCount}
            completedCount={completedCount}
            setCompletedCount={setCompletedCount}
            installsCount={installsCount}
            setInstallsCount={setInstallsCount}
            pickupCount={pickupCount}
            setPickupCount={setPickupCount}
            shippingCount={shippingCount}
            setShippingCount={setShippingCount}
            allRequest={allRequest}
            setAllRequest={setAllRequest}
            loadingCards={loadingCardsAdd}
            setLoadingCards={setLoadingCardsAdd}
            skillServices={skillServices}
            setSkillServices={setSkillServices}
            allProducts={allProducts}
            setAllproducts={setAllproducts}
            materials={materials}
            setAllMaterials={setAllMaterials}
            labourCostServices={labourCostServices}
            setLabourCostServices={setLabourCostServices}
            filteredServices={filteredServices}
            setFilteredServices={setFilteredServices}
            requestTeam={requestTeam}
            setRequestTeam={setRequestTeam}
            openPreview={openPreview}
            setOpenPreview={setOpenPreview}
            isSaving={isSaving}
            setIsSaving={setIsSaving}
            selectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts}
            selectedMaterials={selectedMaterials}
            setSelectedMaterials={setSelectedMaterials}
            selectedServices={selectedServices}
            setSelectedServices={setSelectedServices}
            additionalSelectedServices={additionalSelectedServices}
            setAdditionalSelectedServices={setAdditionalSelectedServices}
            avatarUrl={avatarUrl}
            setAvatarUrl={setAvatarUrl}
            location={location}
            setLocation={setLocation}
            projectTypes={projectTypes}
            setProjectTypes={setProjectTypes}
            workflow={workflow}
            setWorkFlow={setWorkFlow}
            projectCategories={projectCategories}
            setProjectCategories={setProjectCategories}
            noChargeType={noChargeType}
            setNoChargeType={setNoChargeType}
            communities={communities}
            setCommunities={setCommunities}
            isCommunityLoading={isCommunityLoading}
            setIsCommunityLoading={setIsCommunityLoading}
            locationStates={locationStates}
            setLocationStates={setLocationStates}
            serviceOnlyLocationStates={serviceOnlyLocationStates}
            setServiceOnlyLocationStates={setServiceOnlyLocationStates}
            rfpLocationStates={rfpLocationStates}
            setRfpLocationStates={setRfpLocationStates}
            rfpServiceLocationStates={rfpServiceLocationStates}
            setRfpServiceLocationStates={setRfpServiceLocationStates}
            allLocationSame={allLocationSame}
            setAllLocationSame={setAllLocationSame}
            allServiceLocationSame={allServiceLocationSame}
            setAllServiceLocationSame={setAllServiceLocationSame}
            allRfpServiceLocationSame={allRfpServiceLocationSame}
            setAllRfpServiceLocationSame={setAllRfpServiceLocationSame}
            allRfpProductsLocationSame={allRfpProductsLocationSame}
            setAllRfpProductsLocationSame={setAllRfpProductsLocationSame}
            address={address}
            setAddress={setAddress}
            progress={progress}
            setProgress={setProgress}
            currentDate={currentDate}
            setCurrentDate={setCurrentDate}
            user={user}
            userType={userType}
            userId={userId}
            teamId={teamId}
            explodedPermissions={explodedPermissions}
            hasMarkupPermission={hasMarkupPermission}
            hasDiscountPermission={hasDiscountPermission}
            allClients={allClients}
            setAllClients={setAllClients}
            communitiesOpen={communitiesOpen}
            setCommunitiesOpen={setCommunitiesOpen}
            communitiesData={communitiesData}
            setCommunitiesData={setCommunitiesData}
            filterCommunity={filterCommunity}
            setFilterCommunity={setFilterCommunity}
            markupType={markupType}
            setMarkupType={setMarkupType}
            order={order}
            setOrder={setOrder}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            showServices={showServices}
            setShowServices={setShowServices}
            showWarning={showWarning}
            setShowWarning={setShowWarning}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            indexCounter={indexCounter}
            setIndexCounter={setIndexCounter}
            serviceIndexCounter={serviceIndexCounter}
            setServiceIndexCounter={setServiceIndexCounter}
            rfps={rfps}
            setRfps={setRfps}
            selectedRfp={selectedRfp}
            setSelectedRfp={setSelectedRfp}
            openModal={openModal}
            setOpenModal={setOpenModal}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
            rfpServices={rfpServices}
            setRfpServices={setRfpServices}
            rfpProducts={rfpProducts}
            setRfpProducts={setRfpProducts}
            cart={cart}
            setCart={setCart}
            cartService={cartService}
            setCartService={setCartService}
            totalProductLabourCost={totalProductLabourCost}
            filterDateValue={filterDateValue}
            setFilterDateValue={setFilterDateValue}
            sort={sort}
            setSort={setSort}
            sortOpen={sortOpen}
            setSortOpen={setSortOpen}
            noCharge={noCharge}
            setNoCharge={setNoCharge}
            openProductNote={openProductNote}
            setOpenProductNote={setOpenProductNote}
            openServiceNote={openServiceNote}
            setOpenServiceNote={setOpenServiceNote}
            isSavingNote={isSavingNote}
            setIsSavingNote={setIsSavingNote}
            currentNote={currentNote}
            setCurrentNote={setCurrentNote}
            selectedTaxCategory={selectedTaxCategory}
            setSelectedTaxCategory={setSelectedTaxCategory}
            taxCategories={taxCategories}
            setTaxCategories={setTaxCategories}
            isSubmitted={isSubmitted}
            setIsSubmitted={setIsSubmitted}
            allId={allId}
            setAllId={setAllId}
            mapServices={mapServices}
            setMapServices={setMapServices}
            mapServicesLoading={mapServicesLoading}
            setMapServicesLoading={setMapServicesLoading}
            selectedMapserviceProducts={selectedMapserviceProducts}
            setSelectedMapserviceProducts={setSelectedMapserviceProducts}
            newTotalAmount={newTotalAmount}
            setNewTotalAmount={setNewTotalAmount}
            newTotalMarkup={newTotalMarkup}
            setNewTotalMarkup={setNewTotalMarkup}
            newTotalProductFormula={newTotalProductFormula}
            setNewTotalProductFormula={setNewTotalProductFormula}
            newTotalWholesalePrice={newTotalWholesalePrice}
            setNewTotalWholesalePrice={setNewTotalWholesalePrice}
            newTotalRetailPrice={newTotalRetailPrice}
            setNewTotalRetailPrice={setNewTotalRetailPrice}
            newOriginalTotalMarkup={newOriginalTotalMarkup}
            setNewOriginalTotalMarkup={setNewOriginalTotalMarkup}
            newOriginalTotalServiceMarkup={newOriginalTotalServiceMarkup}
            setNewOriginalTotalServiceMarkup={setNewOriginalTotalServiceMarkup}
            newTotalServiceMarkup={newTotalServiceMarkup}
            setNewTotalServiceMarkup={setNewTotalServiceMarkup}
            newTotalDiscount={newTotalDiscount}
            setNewTotalDiscount={setNewTotalDiscount}
            newDiscountTotal={newDiscountTotal}
            setNewDiscountTotal={setNewDiscountTotal}
            newTotalJobcostSum={newTotalJobcostSum}
            setNewTotalJobcostSum={setNewTotalJobcostSum}
            newTotalsum={newTotalsum}
            setNewTotalsum={setNewTotalsum}
            newGrandTotal={newGrandTotal}
            setNewGrandTotal={setNewGrandTotal}
            newValues={newValues}
            setNewValues={setNewValues}
            setRenderCard={setRenderCard}
            renderCard={renderCard}
            setOtherInstallationProducts={setOtherInstallationProducts}
            otherInstallationProducts={otherInstallationProducts}

            splitManagementSettings={splitManagementSettings}
            splitPercentage={splitPercentage}
            setSplitPerscentage={setSplitPerscentage}
            incomingSplitMarkup={incomingSplitMarkup}
            pageSplitOrder = {splitOrder}
            handleOpenViewSalesOrder={handleOpenViewSalesOrder}
            openEmailModal={openEmailModal}
            setOpenEmailModal={setOpenEmailModal}
            
            billingTypes={billingTypes}
          />
        ) : (
          // Wrapper Box to stabilize height and scrollbar behavior,
          // especially on large client displays where tiny height changes
          // were causing the browser's vertical scrollbar to appear/disappear
          // and make the cards flicker.
          <Box
            ref={paginationScrollAnchorRef}
            sx={{
              // Keep at least a viewport of content so the scrollbar
              // doesn't toggle on/off with minor layout changes
              minHeight: 'calc(100vh - 260px)',
              // Reserve gutter space for the scrollbar so card width
              // doesn't jump when the scrollbar appears
              scrollbarGutter: 'stable',
            }}
          >
            {/* <Scrollbar> */}
              <Grid container spacing={2} sx={{mt:1, width: '100%', marginLeft: '0px'}}>
                <Tabs
                  value={currentTab}
                  scrollButtons="auto"
                  variant="scrollable"
                  allowScrollButtonsMobile
                  onChange={handleChangeTab}
                >
                  {ACCOUNT_TABS.map((tabItem) => (
                    <Tab
                      sx={{
                        justifyContent: 'center',
                        overflow: 'visible',
                      }}
                      disableRipple
                      disabled={loadingCards}
                      key={tabItem.value}
                      label={
                        <Typography
                          variant="subtitle2"
                          sx={{
                            textAlign: 'center',
                            ml: 1,
                            fontSize: '13px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          {capitalCase(tabItem.name)}
                          {tabGlowFlags[tabItem.value] === 1 && (
                            <Box
                              component="span"
                              sx={{
                                width: 7,
                                height: 7,
                                borderRadius: '50%',
                                bgcolor: '#28dc0a',
                                flexShrink: 0,
                              }}
                            />
                          )}
                        </Typography>
                      }
                      // label={
                      //     tabItem.count > 0 ?(<>
                      //     <Badge badgeContent={tabItem.count} color="warning" max={9999} showZero>
                      //     <Typography variant="h6">
                      //       {capitalCase(tabItem.name)}
                      //     </Typography>
                      //     </Badge>
                      //     </>)
                      //     :(
                      //     <Typography variant="h6">
                      //       {capitalCase(tabItem.name)}
                      //     </Typography>
                      //   //  </Badge>
                      //   )
                      //   }
                      // icon={tabItem.icon}
                      value={tabItem.value}
                    />
                  ))}
                </Tabs>
                {(isInvoiceGroupingEnabled || isInvoiceListGroupingEnabled) && selectedInvoiceGroupIds.length > 1 && (
                  <Grid item xs={12}>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      alignItems={{ xs: 'flex-start', sm: 'center' }}
                      justifyContent="space-between"
                      spacing={1}
                      sx={{
                        mt: 1,
                        p: 1.5,
                        borderRadius: 1,
                        border: `1px dashed ${theme.palette.primary.main}`,
                        backgroundColor: theme.palette.action.hover,
                      }}
                    >
                      <Typography variant="body2">
                        {getSelectedGroupedParentId(selectedInvoiceGroupIds)
                          ? 'Add the selected sales orders to the existing group.'
                          : 'Group the selected sales orders from the same client and project.'}
                        {` Selected: ${selectedInvoiceGroupRows.length}`}
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        {selectedInvoiceGroupIds.length > 0 && (
                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Icon icon={CloseIcon} width={18} height={18} />}
                            onClick={() => setSelectedInvoiceGroupIds([])}
                            disabled={groupingInvoiceRequests}
                          >
                            Clear
                          </Button>
                        )}
                        <LoadingButton
                          size="small"
                          variant="contained"
                          loading={groupingInvoiceRequests}
                          loadingPosition="start"
                          startIcon={
                            <Icon
                              icon={getSelectedGroupedParentId(selectedInvoiceGroupIds) ? plusCircleOutline : layersFill}
                              width={18}
                              height={18}
                            />
                          }
                          disabled={selectedInvoiceGroupIds.length < 2}
                          onClick={handleGroupInvoiceRequests}
                        >
                          {getSelectedGroupedParentId(selectedInvoiceGroupIds) ? 'Add to existing Group' : 'Combine Sales Orders'}
                        </LoadingButton>
                      </Stack>
                    </Stack>
                  </Grid>
                )}
                {loadingCards ? (
                  // <Grid
                  //   container
                  //   alignItems={'center'}
                  //   justifyContent={'center'}
                  // >
                  //   <Stack sx={{ my: 15 }}>
                  //     <LoadingScreen />
                  //   </Stack>
                  // </Grid>
                  <SkeletonLoad />
                ) : (
                  //   (filteredUsers?.length > 0 ? filteredUsers?.map((row) => {
                  //     const team_member = requestTeam?.length > 0 && requestTeam?.filter(member => member.request_id == row.id) || []

                  //     return (
                  //       <>
                  //       {/* <Grid key={row.id} item xs={12} sm={6} md={4}>
                  //         <OfficialCard card={row} team_member={team_member} key={row.id} />
                  //       </Grid> */}

                  //       <DragDropContext onDragEnd={handleOnDragEnd}>
                  //       <Droppable droppableId="officialRequests" direction="vertical">
                  //         {(provided) => (
                  //           <Grid container spacing={3} {...provided.droppableProps} ref={provided.innerRef}>

                  //             {filteredUsers.map((row, index) => (
                  //               <Draggable key={row.id} draggableId={row.id.toString()} index={index}>
                  //                 {(provided, snapshot) => (
                  //                   <Grid
                  //                   key={row.id}
                  //                     item
                  //                     xs={12}
                  //                     sm={6}
                  //                     md={4}
                  //                     sx={{mt:3}}
                  //                     ref={provided.innerRef}
                  //                     {...provided.draggableProps}
                  //                     {...provided.dragHandleProps}
                  //                     style={{
                  //                       ...provided.draggableProps.style,
                  //                       opacity: snapshot.isDragging ? 0.5 : 1,
                  //                     }}
                  //                   >
                  //                     <OfficialCard card={row} team_member={team_member} key={row.id} />
                  //                   </Grid>
                  //                 )}
                  //               </Draggable>
                  //             ))}
                  //             {provided.placeholder}
                  //           </Grid>
                  //         )}
                  //       </Droppable>
                  //     </DragDropContext>
                  //     </>

                  //     )
                  //   })
                  //   :
                  //   <Grid container alignItems={'center'} justifyContent={'center'}>
                  //     <Stack sx={{my:15}}>
                  //       <Typography gutterBottom align="center" variant="subtitle1">
                  //         No {capitalCase(currentTab)} Requests Found
                  //       </Typography>
                  //     </Stack>
                  //   </Grid>
                  // )
                  <>
                    {filteredUsers?.length > 0 ? (
                      <>
                        {valueTab === 'one' &&
                          <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable
                              droppableId="officialRequests"
                              direction="vertical"
                            >
                              {(provided) => (
                                <Grid
                                  container
                                  spacing={0}
                                  sx={{
                                    display: 'grid',
                                    gap: 0,
                                    gridTemplateColumns: {
                                      xs: '1fr',                 // mobile: 1 per row
                                      sm: 'repeat(2, 1fr)',      // tablet: 2 per row
                                      md: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                      lg: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                      xl: 'repeat(6, minmax(0, 1fr))', // desktop: logical 6-column grid
                                    },
                                    justifyContent: 'center',    // ✅ centers when fewer items
                                  }}
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {filteredUsers.map((row, index) => {
                                    console.log('fgbidfigfiig', row)
                                    console.log(
                                      'fgbidfigfiig',
                                      row.installationCompleteStatus,
                                    )

                                    const team_member =
                                      requestTeam?.length > 0
                                        ? requestTeam.filter(
                                          (member) =>
                                            member.request_id === row.id,
                                        )
                                        : []
                                    return (
                                      <Draggable
                                        key={row.id}
                                        draggableId={row.id.toString()}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <Grid
                                            item
                                            // xs={12}
                                            // sm={6}
                                            // md={2}
                                            sx={{ mt: 3 }}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                              ...provided.draggableProps.style,
                                              opacity: snapshot.isDragging
                                                ? 0.5
                                                : 1,
                                            }}
                                          >
                                            <OfficialCard
                                              card={row}
                                              team_member={team_member}
                                              currentTab={currentTab}
                                              setOpenSalesOrder={setOpenSalesOrder}
                                              opeSalesOrder={opeSalesOrder}
                                              removePopupData={removePopupData}
                                              SalesOrderId={SalesOrderId}
                                              setSalesOrderId={setSalesOrderId}
                                              salesOrderName={salesOrderName}
                                              setSalesOrderName={setSalesOrderName}
                                              renderCards={renderCard}
                                              setRenderCards={setRenderCard}
                                              handleOpenViewSalesOrder={handleOpenViewSalesOrder}
                                              handleOpenDetailsSalesOrder={handleOpenDetailsSalesOrder}
                                              salesOrderNewCard={!!row?.is_new_in_tab}
                                              isSalesOrder={true}
                                              hasViewCostPermission={hasViewCostPermission}
                                              showSelectionCheckbox={canShowInvoiceGroupCheckbox(row)}
                                              selectionChecked={selectedInvoiceGroupIds.includes(row.id)}
                                              onSelectionChange={handleToggleInvoiceGroupSelection}
                                              onGroupedCardClick={(isInvoiceGroupingEnabled || currentTab === 'COMPLETED' || currentTab === 'ALL') && Number(row?.is_grouped_request || 0) === 1 ? handleOpenGroupedInvoiceDialog : undefined}
                                            />
                                          </Grid>
                                        )}
                                      </Draggable>
                                    )
                                  })}
                                  {provided.placeholder}
                                </Grid>
                              )}
                            </Droppable>
                          </DragDropContext>}
                        {valueTab === 'two' &&
                          <DesignOrderList
                            salesOrder={true}
                            estimate={true}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCard}
                            renderCards={renderCard}
                            handleOpenDetailsSalesOrder={handleOpenDetailsSalesOrder}
                            handleOpenViewSalesOrder={handleOpenViewSalesOrder}
                            enableInvoiceGroupAccordion={['INVOICING', 'COMPLETED', 'ALL'].includes(currentTab)}
                            isInvoiceListGroupingEnabled={isInvoiceListGroupingEnabled}
                            selectedInvoiceGroupIds={selectedInvoiceGroupIds}
                            canShowInvoiceGroupCheckbox={canShowInvoiceGroupCheckbox}
                            onToggleInvoiceGroupSelection={handleToggleInvoiceGroupSelection}
                            onClearInvoiceGroupSelection={() => setSelectedInvoiceGroupIds([])}
                            invoiceGroupActionBarVisible={isInvoiceListGroupingEnabled && selectedInvoiceGroupIds.length > 1}
                            onUngroupInvoiceRequests={handleUngroupInvoiceRequests}
                            ungroupingInvoiceRequests={ungroupingInvoiceRequests}
                          />}
                        {valueTab === 'three' &&
                          <DesignOrderList
                            salesOrder={true}
                            estimate={true}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCard}
                            renderCards={renderCard}
                            handleOpenDetailsSalesOrder={handleOpenDetailsSalesOrder}
                            handleOpenViewSalesOrder={handleOpenViewSalesOrder}
                            noImage={true}
                            enableInvoiceGroupAccordion={['INVOICING', 'COMPLETED', 'ALL'].includes(currentTab)}
                            isInvoiceListGroupingEnabled={isInvoiceListGroupingEnabled}
                            selectedInvoiceGroupIds={selectedInvoiceGroupIds}
                            canShowInvoiceGroupCheckbox={canShowInvoiceGroupCheckbox}
                            onToggleInvoiceGroupSelection={handleToggleInvoiceGroupSelection}
                            onClearInvoiceGroupSelection={() => setSelectedInvoiceGroupIds([])}
                            invoiceGroupActionBarVisible={isInvoiceListGroupingEnabled && selectedInvoiceGroupIds.length > 1}
                            onUngroupInvoiceRequests={handleUngroupInvoiceRequests}
                            ungroupingInvoiceRequests={ungroupingInvoiceRequests}
                          />
                        }
                      </>
                    ) : (
                      <Grid
                        container
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        <Stack sx={{ my: 15 }}>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            No {capitalCase(currentTab)} Orders Found
                          </Typography>
                        </Stack>
                      </Grid>
                    )}
                  </>

                )}
              </Grid>
            {/* </Scrollbar> */}
            {/* <Scrollbar>
            {allRequest?.length > 0 && (
              Object.entries(allRequest.reduce((acc, row) => {
                const community = row.community_name || "Others";
                if (!acc[community]) {
                  acc[community] = [];
                }
                acc[community].push(row);
                return acc;
              }, {})).map(([community, groupedRequests]) => (
                <div key={community}>
                  <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleExpandToggle(community)}>
                  {expandedCommunities[community] ? <ExpandLess /> : <ExpandMore />}
                  <Typography variant="h6" sx={{marginTop:2,marginBottom:2}}>{community}</Typography>
                  </div>
                  {expandedCommunities[community] && (
                  <Grid container spacing={3}>
                   {groupedRequests?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((row) => {
                      const team_member = requestTeam?.length > 0 && requestTeam?.filter(member => member.request_id == row.id) || [];
                      // console.log("row-----------------------", row);
                      return (
                        <Grid key={row.id} item xs={12} sm={6} md={4}>
                          <OfficialCard card={row} team_member={team_member} currentTab={currentTab} />
                        </Grid>
                      );
                    })}
                  </Grid>
                  )}
                </div>
              ))
            )}
          </Scrollbar> */}
            {loadingCards ? (
              ''
            ) : (
              <Stack gap={2} sx={{ mt: 2 }}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100, 500]}
                  component="div"
                  count={totalCount || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Stack>
            )}
          </Box>
        )}
        {openPreview && (
          <Modal
            width={900}
            open={openPreview}
            handleClose={() => {
              setOpenPreview(false)
            }}
            modalTitle={'Preview'}
          >
            <OfficialRequestAddPreview
              preview={preview}
              markupType={markupType}
              hasMarkupPermission={hasMarkupPermission}
              hasViewCostPermission={hasViewCostPermission}
              DiscountTotal={newDiscountTotal}
              totalJobcostSum={newTotalJobcostSum}
              totalsum={newTotalsum}
              grandTotal={newGrandTotal}
              noCharge={noCharge}
              selectedMaterials={selectedMaterials}
              cartService={cartService}
              cart={cart}
              additionalSelectedServices={additionalSelectedServices}
              selectedServices={selectedServices}
              selectedProducts={selectedProducts}
              values={newValues}
            />
          </Modal>
        )}
      </Container>
      <Dialog
        open={groupedInvoiceDialog.open}
        onClose={handleCloseGroupedInvoiceDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="subtitle1">
              {getGroupedInvoiceDisplayName(groupedInvoiceDialog.card)}
            </Typography>
            <IconButton onClick={handleCloseGroupedInvoiceDialog} size="small">
              <Icon icon={CloseIcon} width={20} height={20} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          {!hideGroupedUngroupControls && (
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              justifyContent="space-between"
              spacing={1}
              sx={{ mb: 2 }}
            >
              <Typography variant="body2">
                Select sales orders to remove from this group.
                {selectedGroupedUngroupIds.length > 0 ? ` Selected: ${selectedGroupedUngroupIds.length}` : ''}
              </Typography>
              {selectedGroupedUngroupIds.length > 0 && (
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<Icon icon={CloseIcon} width={18} height={18} />}
                    onClick={() => setSelectedGroupedUngroupIds([])}
                    disabled={ungroupingInvoiceRequests}
                  >
                    Clear
                  </Button>
                  <LoadingButton
                    size="small"
                    variant="contained"
                    color="error"
                    loading={ungroupingInvoiceRequests}
                    loadingPosition="start"
                    startIcon={<CallSplit sx={{ width: 18, height: 18 }} />}
                    onClick={() => handleUngroupInvoiceRequests()}
                  >
                    Ungroup Selected
                  </LoadingButton>
                </Stack>
              )}
            </Stack>
          )}
          <Grid
            container
            spacing={2}
            sx={{
              pb: 2,
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))',
              },
            }}
          >
            {(groupedInvoiceDialog.card?.grouped_requests || []).map((groupedRow, groupedIndex) => {
              const team_member =
                requestTeam?.length > 0
                  ? requestTeam.filter((member) => member.request_id === groupedRow.id)
                  : []
              return (
                <Grid key={groupedRow.id} item sx={{ mt: 1 }}>
                  <OfficialCard
                    card={{
                      ...groupedRow,
                      is_grouped_request: 0,
                      grouped_request_ids: null,
                      grouped_requests: undefined,
                      grouped_quantity: undefined,
                    }}
                    team_member={team_member}
                    currentTab={currentTab}
                    setOpenSalesOrder={setOpenSalesOrder}
                    opeSalesOrder={opeSalesOrder}
                    removePopupData={removePopupData}
                    SalesOrderId={SalesOrderId}
                    setSalesOrderId={setSalesOrderId}
                    salesOrderName={salesOrderName}
                    setSalesOrderName={setSalesOrderName}
                    renderCards={renderCard}
                    setRenderCards={setRenderCard}
                    handleOpenViewSalesOrder={(requestId, requestName) => {
                      handleCloseGroupedInvoiceDialog()
                      handleOpenViewSalesOrder(requestId, requestName)
                    }}
                    handleOpenDetailsSalesOrder={(requestId, requestName) => {
                      handleCloseGroupedInvoiceDialog()
                      handleOpenDetailsSalesOrder(requestId, requestName)
                    }}
                    isSalesOrder={true}
                    hasViewCostPermission={hasViewCostPermission}
                    isInvoiceGroupDialogItem
                    groupedParentRequestId={groupedInvoiceDialog.card?.id}
                    invoiceSequenceIndex={groupedIndex + 1}
                    showSelectionCheckbox={!hideGroupedUngroupControls}
                    selectionChecked={selectedGroupedUngroupIds.includes(groupedRow.id)}
                    onSelectionChange={handleToggleGroupedUngroupSelection}
                  />
                </Grid>
              )
            })}
          </Grid>
        </DialogContent>
      </Dialog>
      <FullScreenDialogSalesOrder
        open={opeSalesOrder}
        setOpen={setOpenSalesOrder}
        handleClickOpen={handleOpenViewSalesOrder}
        projectName={salesOrderName}
        removePopupData={removePopupData}
        projectId={SalesOrderId}
        isEditSalesOrder={isEditSalesOrder}
        combineGroupedInvoice={salesOrderCombineGrouped}
        setRenderCards={setRenderCard}
        renderCards={renderCard}
        isFromCompletedTab={currentTab === 'COMPLETED' || currentTab === 'ARCHIVE'}
        openEmailModal={openEmailModal}
        setOpenEmailModal={setOpenEmailModal}
        mainCurrentTab={currentTab}
      />
    </Page>
  )
}
